export const customIcons: Record<string, any> = {
  github: [
    [
      "path",
      {
        d: "M10.5 0.5C4.97788 0.5 0.5 4.9771 0.5 10.5C0.5 14.9184 3.36531 18.6668 7.33866 19.9891C7.83841 20.0817 8.02193 19.7722 8.02193 19.508C8.02193 19.2696 8.0126 18.4818 8.00836 17.6462C5.22626 18.2511 4.63923 16.4663 4.63923 16.4663C4.18434 15.3105 3.52891 15.0032 3.52891 15.0032C2.62165 14.3825 3.5973 14.3952 3.5973 14.3952C4.6015 14.4658 5.13027 15.4257 5.13027 15.4257C6.02216 16.9546 7.46964 16.5125 8.04028 16.2571C8.13 15.6107 8.38921 15.1696 8.67516 14.9199C6.45406 14.667 4.11909 13.8095 4.11909 9.97778C4.11909 8.88606 4.50974 7.99393 5.14948 7.29364C5.04564 7.04173 4.70338 6.02467 5.24634 4.64723C5.24634 4.64723 6.08608 4.37845 7.99707 5.67229C8.79469 5.45065 9.65019 5.33959 10.5 5.33583C11.3499 5.33959 12.206 5.45065 13.0052 5.67229C14.9139 4.37845 15.7525 4.64723 15.7525 4.64723C16.2968 6.02467 15.9544 7.04173 15.8505 7.29364C16.4917 7.99393 16.8797 8.88598 16.8797 9.97778C16.8797 13.8186 14.5403 14.6644 12.3135 14.9119C12.6722 15.2222 12.9918 15.8308 12.9918 16.7637C12.9918 18.1017 12.9802 19.1786 12.9802 19.508C12.9802 19.7741 13.1602 20.086 13.6671 19.9878C17.6383 18.664 20.5 14.9169 20.5 10.5C20.5 4.9771 16.0227 0.5 10.5 0.5Z",
        fill: "currentColor",
        stroke: "none"
      }
    ],
    [
      "path",
      {
        d: "M4.2455 14.7453C4.22354 14.7949 4.14527 14.8098 4.07413 14.7758C4.00159 14.7431 3.9608 14.6754 3.98433 14.6255C4.0059 14.5744 4.08417 14.5601 4.15656 14.5944C4.22926 14.627 4.27067 14.6954 4.2455 14.7453ZM4.7374 15.1841C4.68972 15.2284 4.59647 15.2078 4.53318 15.138C4.46777 15.0682 4.45553 14.9751 4.50392 14.9301C4.5531 14.886 4.64352 14.9066 4.70909 14.9764C4.7745 15.0469 4.78721 15.1395 4.73732 15.1842M5.07488 15.7457C5.01355 15.7883 4.91332 15.7484 4.85144 15.6594C4.79019 15.5706 4.79019 15.4639 4.85277 15.4212C4.91489 15.3784 5.01355 15.4168 5.07629 15.5051C5.13747 15.5955 5.13747 15.7022 5.0748 15.7458M5.64553 16.3961C5.59071 16.4565 5.474 16.4403 5.38852 16.3578C5.30115 16.2772 5.27676 16.1628 5.33174 16.1023C5.38718 16.0418 5.50459 16.0588 5.59071 16.1406C5.67753 16.221 5.70404 16.3363 5.64561 16.3961M6.38307 16.6157C6.35899 16.694 6.24653 16.7296 6.13328 16.6963C6.02018 16.6621 5.94615 16.5703 5.96897 16.4912C5.9925 16.4123 6.10543 16.3752 6.21955 16.4108C6.33248 16.445 6.40668 16.536 6.38315 16.6157M7.22257 16.7088C7.22539 16.7913 7.12932 16.8597 7.01042 16.8612C6.89082 16.8638 6.79411 16.797 6.79286 16.7159C6.79286 16.6326 6.88674 16.5649 7.00626 16.5629C7.12516 16.5606 7.22257 16.6268 7.22257 16.7088ZM8.04717 16.6772C8.06144 16.7577 7.97878 16.8403 7.86074 16.8623C7.74467 16.8835 7.63722 16.8338 7.6224 16.754C7.60797 16.6715 7.6922 16.589 7.80804 16.5675C7.92631 16.547 8.03211 16.5954 8.04717 16.6772Z",
        fill: "currentColor",
        stroke: "none"
      }
    ]
  ],

  google: [
    [
      "path",
      {
        d: "M19.1739 10.2106C19.1739 9.43171 19.112 8.86334 18.9782 8.27393H10.2724V11.7894H15.3825C15.2795 12.663 14.7232 13.9787 13.4868 14.8628L13.4695 14.9805L16.2221 17.159L16.4128 17.1784C18.1642 15.5259 19.1739 13.0945 19.1739 10.2106Z",
        fill: "#4285F4",
        stroke: "none"
      }
    ],
    [
      "path",
      {
        d: "M10.2724 19.4729C12.7759 19.4729 14.8776 18.6308 16.4128 17.1783L13.4868 14.8627C12.7038 15.4205 11.6529 15.81 10.2724 15.81C7.82036 15.81 5.73924 14.1575 4.99738 11.8735L4.88864 11.883L2.02644 14.1459L1.98901 14.2522C3.51379 17.3467 6.64581 19.4729 10.2724 19.4729Z",
        fill: "#34A853",
        stroke: "none"
      }
    ],
    [
      "path",
      {
        d: "M4.9974 11.8736C4.80165 11.2842 4.68836 10.6526 4.68836 10C4.68836 9.34742 4.80165 8.71592 4.9871 8.12651L4.98191 8.00098L2.08385 5.70166L1.98903 5.74774C1.3606 7.03185 1 8.47386 1 10C1 11.5262 1.3606 12.9682 1.98903 14.2523L4.9974 11.8736Z",
        fill: "#FBBC05",
        stroke: "none"
      }
    ],
    [
      "path",
      {
        d: "M10.2724 4.19016C12.0135 4.19016 13.188 4.95851 13.8577 5.6006L16.4746 2.99029C14.8674 1.46411 12.7759 0.527344 10.2724 0.527344C6.64581 0.527344 3.51379 2.65346 1.98901 5.7479L4.98708 8.12667C5.73924 5.84267 7.82036 4.19016 10.2724 4.19016Z",
        fill: "#EB4335",
        stroke: "none"
      }
    ]
  ],

  info: [
    [
      "circle",
      {
        cx: "12",
        cy: "12",
        r: "10",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ],
    [
      "path",
      {
        d: "M12 16v-4",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        fill: "none"
      }
    ],
    [
      "path",
      {
        d: "M12 8h.01",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        fill: "none"
      }
    ]
  ],

  messageCircleText: [
    [
      "path",
      {
        d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 13.5997 2.37562 15.1116 3.04346 16.4525C3.22094 16.8088 3.28001 17.2161 3.17712 17.6006L2.58151 19.8267C2.32295 20.793 3.20701 21.677 4.17335 21.4185L6.39939 20.8229C6.78393 20.72 7.19121 20.7791 7.54753 20.9565C8.88837 21.6244 10.4003 22 12 22ZM8 13.25C7.58579 13.25 7.25 13.5858 7.25 14C7.25 14.4142 7.58579 14.75 8 14.75H13.5C13.9142 14.75 14.25 14.4142 14.25 14C14.25 13.5858 13.9142 13.25 13.5 13.25H8ZM7.25 10.5C7.25 10.0858 7.58579 9.75 8 9.75H16C16.4142 9.75 16.75 10.0858 16.75 10.5C16.75 10.9142 16.4142 11.25 16 11.25H8C7.58579 11.25 7.25 10.9142 7.25 10.5Z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        fill: "currentColor",
        stroke: "none"
      }
    ]
  ],

  bell: [
    [
      "path",
      {
        d: "M8.35179 20.2418C9.19288 21.311 10.5142 22 12 22C13.4858 22 14.8071 21.311 15.6482 20.2418C13.2264 20.57 10.7736 20.57 8.35179 20.2418Z",
        fill: "currentColor",
        stroke: "none"
      }
    ],
    [
      "path",
      {
        d: "M18.7491 9V9.7041C18.7491 10.5491 18.9903 11.3752 19.4422 12.0782L20.5496 13.8012C21.5612 15.3749 20.789 17.5139 19.0296 18.0116C14.4273 19.3134 9.57274 19.3134 4.97036 18.0116C3.21105 17.5139 2.43882 15.3749 3.45036 13.8012L4.5578 12.0782C5.00972 11.3752 5.25087 10.5491 5.25087 9.7041V9C5.25087 5.13401 8.27256 2 12 2C15.7274 2 18.7491 5.13401 18.7491 9Z",
        fill: "currentColor",
        stroke: "none"
      }
    ]
  ],

  settings: [
    [
      "path",
      {
        d: "M14.2788 2.15224C13.9085 2 13.439 2 12.5 2C11.561 2 11.0915 2 10.7212 2.15224C10.2274 2.35523 9.83509 2.74458 9.63056 3.23463C9.53719 3.45834 9.50065 3.7185 9.48635 4.09799C9.46534 4.65568 9.17716 5.17189 8.69017 5.45093C8.20318 5.72996 7.60864 5.71954 7.11149 5.45876C6.77318 5.2813 6.52789 5.18262 6.28599 5.15102C5.75609 5.08178 5.22018 5.22429 4.79616 5.5472C4.47814 5.78938 4.24339 6.1929 3.7739 6.99993C3.30441 7.80697 3.06967 8.21048 3.01735 8.60491C2.94758 9.1308 3.09118 9.66266 3.41655 10.0835C3.56506 10.2756 3.77377 10.437 4.0977 10.639C4.57391 10.936 4.88032 11.4419 4.88029 12C4.88026 12.5581 4.57386 13.0639 4.0977 13.3608C3.77372 13.5629 3.56497 13.7244 3.41645 13.9165C3.09108 14.3373 2.94749 14.8691 3.01725 15.395C3.06957 15.7894 3.30432 16.193 3.7738 17C4.24329 17.807 4.47804 18.2106 4.79606 18.4527C5.22008 18.7756 5.75599 18.9181 6.28589 18.8489C6.52778 18.8173 6.77305 18.7186 7.11133 18.5412C7.60852 18.2804 8.2031 18.27 8.69012 18.549C9.17714 18.8281 9.46533 19.3443 9.48635 19.9021C9.50065 20.2815 9.53719 20.5417 9.63056 20.7654C9.83509 21.2554 10.2274 21.6448 10.7212 21.8478C11.0915 22 11.561 22 12.5 22C13.439 22 13.9085 22 14.2788 21.8478C14.7726 21.6448 15.1649 21.2554 15.3694 20.7654C15.4628 20.5417 15.4994 20.2815 15.5137 19.902C15.5347 19.3443 15.8228 18.8281 16.3098 18.549C16.7968 18.2699 17.3914 18.2804 17.8886 18.5412C18.2269 18.7186 18.4721 18.8172 18.714 18.8488C19.2439 18.9181 19.7798 18.7756 20.2038 18.4527C20.5219 18.2105 20.7566 17.807 21.2261 16.9999C21.6956 16.1929 21.9303 15.7894 21.9827 15.395C22.0524 14.8691 21.9088 14.3372 21.5835 13.9164C21.4349 13.7243 21.2262 13.5628 20.9022 13.3608C20.4261 13.0639 20.1197 12.558 20.1197 11.9999C20.1197 11.4418 20.4261 10.9361 20.9022 10.6392C21.2263 10.4371 21.435 10.2757 21.5836 10.0835C21.9089 9.66273 22.0525 9.13087 21.9828 8.60497C21.9304 8.21055 21.6957 7.80703 21.2262 7C20.7567 6.19297 20.522 5.78945 20.2039 5.54727C19.7799 5.22436 19.244 5.08185 18.7141 5.15109C18.4722 5.18269 18.2269 5.28136 17.8887 5.4588C17.3915 5.71959 16.7969 5.73002 16.3099 5.45096C15.8229 5.17191 15.5347 4.65566 15.5136 4.09794C15.4993 3.71848 15.4628 3.45833 15.3694 3.23463C15.1649 2.74458 14.7726 2.35523 14.2788 2.15224ZM12.5 15C14.1695 15 15.5228 13.6569 15.5228 12C15.5228 10.3431 14.1695 9 12.5 9C10.8305 9 9.47716 10.3431 9.47716 12C9.47716 13.6569 10.8305 15 12.5 15Z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        fill: "currentColor",
        stroke: "none"
      }
    ]
  ],

  plus: [
    [
      "path",
      {
        d: "M10 4v12M4 10h12",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        fill: "none"
      }
    ]
  ],

  attach: [
    [
      "path",
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M5.99618 0.46988C7.12948 -0.156627 8.52305 -0.156627 9.65636 0.46988C10.0761 0.701943 10.4679 1.07717 11.1044 1.68676C11.1249 1.70643 11.1457 1.72635 11.1668 1.74651C11.1888 1.76758 11.2105 1.78837 11.2319 1.8089C11.8659 2.41575 12.2587 2.79174 12.5026 3.19622C13.1658 4.29603 13.1658 5.65415 12.5026 6.75396C12.2587 7.15845 11.8659 7.53443 11.2319 8.14129C11.2105 8.16182 11.1888 8.18261 11.1668 8.20367L6.19547 12.9637C5.84262 13.3016 5.55506 13.5769 5.30206 13.781C5.03998 13.9924 4.78192 14.1554 4.47899 14.2425C4.05767 14.3636 3.60896 14.3636 3.18764 14.2425C2.8847 14.1554 2.62664 13.9924 2.36457 13.781C2.11157 13.5769 1.82403 13.3016 1.4712 12.9637L1.43931 12.9332C1.08671 12.5956 0.799081 12.3202 0.585745 12.0777C0.365433 11.8273 0.191245 11.5763 0.0974673 11.2773C-0.0324887 10.8629 -0.0324895 10.4205 0.0974671 10.0061C0.191245 9.7071 0.365433 9.45608 0.585745 9.20567C0.799082 8.96318 1.08671 8.68779 1.43931 8.35018L6.33963 3.65814C6.35718 3.64133 6.37451 3.62469 6.39166 3.60823C6.63791 3.37188 6.84586 3.17229 7.0862 3.06147C7.50937 2.86634 8.00056 2.86634 8.42373 3.06147C8.66407 3.17229 8.87201 3.37188 9.11827 3.60823C9.13542 3.62469 9.15275 3.64133 9.1703 3.65814C9.18846 3.67552 9.20646 3.69271 9.22427 3.70972C9.46894 3.94336 9.67933 4.14426 9.79731 4.37884C10.0082 4.79814 10.0082 5.28859 9.79731 5.70789C9.728 5.8457 9.63567 5.95997 9.53666 6.06656C9.44216 6.1683 9.32114 6.28418 9.1803 6.41902L4.25041 11.1394C4.05096 11.3304 3.73445 11.3235 3.54347 11.124C3.35249 10.9246 3.35937 10.6081 3.55882 10.4171L8.47871 5.7063C8.63231 5.55923 8.73183 5.46367 8.80397 5.386C8.87383 5.31079 8.8952 5.27596 8.90394 5.25857C8.97266 5.12194 8.97266 4.96479 8.90394 4.82816C8.87441 4.76943 8.80862 4.69631 8.47871 4.38042C8.15076 4.06642 8.07207 4.0005 8.00499 3.96957C7.84754 3.89697 7.66239 3.89697 7.50494 3.96957C7.43786 4.0005 7.35916 4.06642 7.03122 4.38042L2.14698 9.05708C1.77442 9.4138 1.51818 9.65974 1.33653 9.86621C1.15863 10.0684 1.08575 10.1966 1.05164 10.3054C0.982785 10.5249 0.982786 10.7584 1.05164 10.978C1.08575 11.0868 1.15863 11.215 1.33653 11.4172C1.51818 11.6236 1.77442 11.8696 2.14698 12.2263C2.51942 12.5829 2.77644 12.8284 2.99239 13.0026C3.20303 13.1725 3.34103 13.2461 3.46396 13.2814C3.70472 13.3506 3.9619 13.3506 4.20266 13.2814C4.3256 13.2461 4.4636 13.1725 4.67424 13.0026C4.89019 12.8284 5.14721 12.5829 5.51965 12.2263L10.4752 7.48138C11.1953 6.7919 11.4802 6.51295 11.6463 6.23759C12.1179 5.45539 12.1179 4.49479 11.6463 3.71259C11.4802 3.43723 11.1953 3.15828 10.4752 2.4688C9.75629 1.78046 9.46352 1.50591 9.17255 1.34505C8.34031 0.884982 7.31222 0.884982 6.47998 1.34505C6.18901 1.50591 5.89624 1.78046 5.17735 2.4688L1.18439 6.29205C0.984939 6.48303 0.668431 6.47615 0.477453 6.2767C0.286476 6.07724 0.293348 5.76074 0.492803 5.56976L4.48576 1.74651C4.50681 1.72635 4.52761 1.70643 4.54815 1.68676C5.18462 1.07717 5.57639 0.701943 5.99618 0.46988Z",
        fill: "currentColor"
      }
    ]
  ],

  magicStick: [
    [
      "path",
      {
        d: "M3.20377 3.20373C2.26541 4.14209 2.26541 5.66348 3.20377 6.60185L4.52689 7.92496C4.53682 7.91347 4.54724 7.90226 4.55815 7.89135L7.89149 4.55802C7.90236 4.54714 7.91354 4.53675 7.92499 4.52684L6.60189 3.20373C5.66352 2.26537 4.14214 2.26537 3.20377 3.20373Z",
        fill: "currentColor"
      }
    ],
    [
      "path",
      {
        d: "M8.80655 5.40839C8.79664 5.41985 8.78625 5.43102 8.77537 5.4419L5.44204 8.77523C5.43113 8.78614 5.41991 8.79657 5.40843 8.8065L13.3981 16.7962C14.3365 17.7345 15.8579 17.7345 16.7962 16.7962C17.7346 15.8578 17.7346 14.3364 16.7962 13.3981L8.80655 5.40839Z",
        fill: "currentColor"
      }
    ],
    [
      "path",
      {
        d: "M13.4167 1.92262C13.5508 1.5813 14.0321 1.5813 14.1662 1.92262L14.5249 2.83535C14.5658 2.93956 14.648 3.02205 14.7518 3.06315L15.6612 3.42313C16.0013 3.55774 16.0013 4.0408 15.6612 4.17541L14.7518 4.53539C14.648 4.57649 14.5658 4.65898 14.5249 4.76318L14.1662 5.67592C14.0321 6.01724 13.5508 6.01724 13.4167 5.67592L13.058 4.76318C13.0171 4.65898 12.9349 4.57649 12.8311 4.53539L11.9217 4.17541C11.5817 4.0408 11.5817 3.55774 11.9217 3.42313L12.8311 3.06315C12.9349 3.02205 13.0171 2.93956 13.058 2.83535L13.4167 1.92262Z",
        fill: "currentColor"
      }
    ],
    [
      "path",
      {
        d: "M16.6393 7.60784C16.7734 7.26652 17.2547 7.26652 17.3888 7.60784L17.5196 7.94063C17.5605 8.04483 17.6427 8.12732 17.7466 8.16842L18.0781 8.29967C18.4182 8.43429 18.4182 8.91734 18.0781 9.05195L17.7466 9.1832C17.6427 9.2243 17.5605 9.30679 17.5196 9.411L17.3888 9.74379C17.2547 10.0851 16.7734 10.0851 16.6393 9.74379L16.5086 9.411C16.4676 9.30679 16.3854 9.2243 16.2816 9.1832L15.95 9.05195C15.61 8.91734 15.61 8.43429 15.95 8.29967L16.2816 8.16842C16.3854 8.12732 16.4676 8.04483 16.5086 7.94063L16.6393 7.60784Z",
        fill: "currentColor"
      }
    ],
    [
      "path",
      {
        d: "M4.27766 12.7559C4.41178 12.4146 4.89306 12.4146 5.02718 12.7559L5.15794 13.0887C5.19889 13.1929 5.28107 13.2754 5.3849 13.3165L5.71646 13.4478C6.05652 13.5824 6.05652 14.0655 5.71646 14.2001L5.3849 14.3313C5.28107 14.3724 5.19889 14.4549 5.15794 14.5591L5.02718 14.8919C4.89306 15.2332 4.41178 15.2332 4.27766 14.8919L4.1469 14.5591C4.10595 14.4549 4.02377 14.3724 3.91994 14.3313L3.58838 14.2001C3.24832 14.0655 3.24832 13.5824 3.58838 13.4478L3.91994 13.3165C4.02377 13.2754 4.10595 13.1929 4.1469 13.0887L4.27766 12.7559Z",
        fill: "currentColor"
      }
    ]
  ],

  moon: [
    [
      "path",
      {
        d: "M10.0003 18.3333C14.6027 18.3333 18.3337 14.6024 18.3337 9.99999C18.3337 9.61441 17.7558 9.55069 17.5564 9.88069C16.6078 11.4505 14.8849 12.5 12.917 12.5C9.92545 12.5 7.50033 10.0749 7.50033 7.08332C7.50033 5.11537 8.5498 3.39253 10.1196 2.44396C10.4496 2.24455 10.3859 1.66666 10.0003 1.66666C5.39795 1.66666 1.66699 5.39762 1.66699 9.99999C1.66699 14.6024 5.39795 18.3333 10.0003 18.3333Z",
        fill: "currentColor",
        stroke: "none"
      }
    ]
  ],

  logout: [
    [
      "path",
      {
        d: "M6.56218 9.99992C6.56218 9.65474 6.842 9.37492 7.18718 9.37492L16.331 9.37492L14.6971 7.97445C14.435 7.74982 14.4047 7.35525 14.6293 7.09317C14.8539 6.8311 15.2485 6.80074 15.5106 7.02538L18.4273 9.52538C18.5658 9.64412 18.6455 9.81746 18.6455 9.99992C18.6455 10.1824 18.5658 10.3557 18.4273 10.4745L15.5106 12.9745C15.2485 13.1991 14.8539 13.1687 14.6293 12.9067C14.4047 12.6446 14.435 12.25 14.6971 12.0254L16.331 10.6249L7.18718 10.6249C6.842 10.6249 6.56218 10.3451 6.56218 9.99992Z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        fill: "currentColor",
        stroke: "none"
      }
    ],
    [
      "path",
      {
        d: "M12.1872 6.66659C12.1872 7.25174 12.1872 7.54432 12.0467 7.7545C11.9859 7.84551 11.9078 7.92365 11.8168 7.98446C11.6066 8.12488 11.314 8.12488 10.7289 8.12488L7.18718 8.12489C6.15164 8.12489 5.31218 8.96435 5.31218 9.99988C5.31218 11.0354 6.15164 11.8749 7.18718 11.8749L10.7288 11.8749C11.314 11.8749 11.6066 11.8749 11.8168 12.0153C11.9078 12.0761 11.9859 12.1542 12.0467 12.2452C12.1872 12.4554 12.1872 12.748 12.1872 13.3333C12.1872 15.6903 12.1872 16.8688 11.4549 17.601C10.7227 18.3333 9.54438 18.3333 7.18736 18.3333L6.35403 18.3333C3.99701 18.3333 2.8185 18.3333 2.08626 17.601C1.35403 16.8688 1.35403 15.6903 1.35403 13.3333L1.35403 6.66659C1.35403 4.30957 1.35403 3.13105 2.08626 2.39882C2.81849 1.66659 3.99701 1.66659 6.35403 1.66659L7.18736 1.66659C9.54438 1.66659 10.7227 1.66659 11.4549 2.39882C12.1872 3.13105 12.1872 4.30956 12.1872 6.66659Z",
        fill: "currentColor",
        stroke: "none"
      }
    ]
  ],

  eye: [
    [
      "path",
      {
        d: "M15 11.5C15 13.2 13.7 14.5 12 14.5C10.3 14.5 9 13.2 9 11.5C9 9.8 10.3 8.5 12 8.5C13.7 8.5 15 9.8 15 11.5ZM23 11.5C23 11.9 22.9 12.4 22.6 12.7C21 14.8 17.5 19 12 19C6.5 19 3 14.8 1.4 12.7C1.1 12.4 1 11.9 1 11.5C1 11.1 1.1 10.6 1.4 10.3C3 8.2 6.5 4 12 4C17.5 4 21 8.2 22.6 10.3C22.9 10.6 23 11.1 23 11.5ZM17 11.5C17 8.7 14.8 6.5 12 6.5C9.2 6.5 7 8.7 7 11.5C7 14.3 9.2 16.5 12 16.5C14.8 16.5 17 14.3 17 11.5Z",
        fill: "currentColor",
        stroke: "none"
      }
    ]
  ],

  eyeOff: [
    [
      "path",
      {
        d: "M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        fill: "none"
      }
    ],
    [
      "path",
      {
        d: "M14.084 14.158a3 3 0 0 1-4.242-4.242",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        fill: "none"
      }
    ],
    [
      "path",
      {
        d: "M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        fill: "none"
      }
    ],
    [
      "path",
      {
        d: "m2 2 20 20",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        fill: "none"
      }
    ]
  ],

  clear: [
    [
      "path",
      {
        d: "M12 3C7 3 3 7 3 12C3 17 7 21 12 21C17 21 21 17 21 12C21 7 17 3 12 3ZM16.2 14.8C16.6 15.2 16.6 15.8 16.2 16.2C15.8 16.6 15.2 16.6 14.8 16.2C14.1 15.5 12 13.4 12 13.4C12 13.4 9.9 15.5 9.2 16.2C8.8 16.6 8.2 16.6 7.8 16.2C7.4 15.8 7.4 15.2 7.8 14.8C8.5 14.1 10.6 12 10.6 12C10.6 12 8.5 9.9 7.8 9.2C7.4 8.8 7.4 8.2 7.8 7.8C8.2 7.4 8.8 7.4 9.2 7.8C9.9 8.5 12 10.6 12 10.6C12 10.6 14.1 8.5 14.8 7.8C15.2 7.4 15.8 7.4 16.2 7.8C16.6 8.2 16.6 8.8 16.2 9.2L13.4 12C13.4 12 15.5 14.1 16.2 14.8Z",
        fill: "currentColor",
        stroke: "none"
      }
    ]
  ],

  chevronLeft: [
    [
      "path",
      {
        d: "M8.14286 14L3 8L8.14286 2",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        fill: "none"
      }
    ]
  ],

  chevronRight: [
    [
      "path",
      {
        d: "M7.85714 2L13 8L7.85714 14",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        fill: "none"
      }
    ]
  ],

  triangleAlert: [
    [
      "path",
      {
        d: "M5.31171 10.7615C8.23007 5.58716 9.68925 3 12 3C14.3107 3 15.7699 5.58716 18.6883 10.7615L19.0519 11.4063C21.4771 15.7061 22.6897 17.856 21.5937 19.428C20.4978 21 17.7864 21 12.3637 21H11.6363C6.21356 21 3.50217 21 2.40626 19.428C1.31034 17.856 2.52291 15.7061 4.94805 11.4063L5.31171 10.7615ZM12 7.25C12.4142 7.25 12.75 7.58579 12.75 8V13C12.75 13.4142 12.4142 13.75 12 13.75C11.5858 13.75 11.25 13.4142 11.25 13V8C11.25 7.58579 11.5858 7.25 12 7.25ZM12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        fill: "currentColor",
        stroke: "none"
      }
    ]
  ],

  clock: [
    [
      "path",
      {
        d: "M10 18.3334C14.0301 18.3334 17.2972 15.0969 17.2972 11.1045C17.2972 7.11213 14.0301 3.87565 10 3.87565C5.96986 3.87565 2.70278 7.11213 2.70278 11.1045C2.70278 15.0969 5.96986 18.3334 10 18.3334ZM10 7.28929C10.3358 7.28929 10.6081 7.559 10.6081 7.8917V10.855L12.457 12.6866C12.6945 12.9218 12.6945 13.3033 12.457 13.5385C12.2195 13.7738 11.8345 13.7738 11.597 13.5385L9.57001 11.5305C9.45597 11.4175 9.3919 11.2643 9.3919 11.1045V7.8917C9.3919 7.559 9.66416 7.28929 10 7.28929Z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        fill: "currentColor",
        stroke: "none"
      }
    ],
    [
      "path",
      {
        d: "M6.86708 1.94996C7.04508 2.23209 6.9585 2.60375 6.6737 2.78008L3.43047 4.7881C3.14568 4.96443 2.77051 4.87866 2.59251 4.59653C2.41452 4.3144 2.50109 3.94275 2.78589 3.76642L6.02912 1.75839C6.31392 1.58206 6.68908 1.66783 6.86708 1.94996Z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        fill: "currentColor",
        stroke: "none"
      }
    ],
    [
      "path",
      {
        d: "M13.1329 1.94996C13.3109 1.66783 13.6861 1.58206 13.9709 1.7584L17.2141 3.76642C17.4989 3.94275 17.5855 4.3144 17.4075 4.59653C17.2295 4.87866 16.8543 4.96443 16.5695 4.7881L13.3263 2.78008C13.0415 2.60374 12.9549 2.23209 13.1329 1.94996Z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        fill: "currentColor",
        stroke: "none"
      }
    ]
  ],

  close: [
    [
      "path",
      {
        d: "M13.4 12.5C13.4 12.5 17 8.9 18.2 7.7C18.6 7.3 18.6 6.7 18.2 6.3C17.8 5.9 17.2 5.9 16.8 6.3C15.6 7.5 12 11.1 12 11.1C12 11.1 8.4 7.5 7.2 6.3C6.8 5.9 6.2 5.9 5.8 6.3C5.4 6.7 5.4 7.3 5.8 7.7C7 8.9 10.6 12.5 10.6 12.5C10.6 12.5 7 16.1 5.8 17.3C5.4 17.7 5.4 18.3 5.8 18.7C6.2 19.1 6.8 19.1 7.2 18.7C8.4 17.5 12 13.9 12 13.9C12 13.9 15.6 17.5 16.8 18.7C17.2 19.1 17.8 19.1 18.2 18.7C18.6 18.3 18.6 17.7 18.2 17.3C17 16.1 13.4 12.5 13.4 12.5Z",
        fill: "currentColor",
        stroke: "none"
      }
    ]
  ],

  upgrade: [
    [
      "path",
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M18.1988 9.27201L18.0078 11.3014C17.6931 14.6452 17.5358 16.3171 16.5502 17.3253C15.5647 18.3334 14.0877 18.3334 11.1336 18.3334H8.86706C5.91296 18.3334 4.43592 18.3334 3.4504 17.3253C2.46489 16.3171 2.30754 14.6452 1.99283 11.3014L1.80183 9.27201C1.65183 7.67816 1.57682 6.88124 1.84948 6.55181C1.99697 6.37361 2.19754 6.26442 2.41198 6.24558C2.8084 6.21076 3.30623 6.7775 4.30188 7.91097C4.8168 8.49716 5.07426 8.79025 5.36147 8.83564C5.52061 8.86079 5.68276 8.83494 5.82971 8.76098C6.09492 8.62752 6.27174 8.26518 6.62538 7.54051L8.48944 3.7208C9.1577 2.35143 9.49183 1.66675 10.0003 1.66675C10.5088 1.66675 10.843 2.35143 11.5112 3.72079L13.3753 7.54051C13.7289 8.26518 13.9057 8.62752 14.1709 8.76098C14.3179 8.83494 14.48 8.86079 14.6392 8.83564C14.9264 8.79025 15.1839 8.49716 15.6988 7.91097C16.6944 6.7775 17.1923 6.21076 17.5887 6.24558C17.8031 6.26442 18.0037 6.37361 18.1512 6.55181C18.4238 6.88124 18.3488 7.67816 18.1988 9.27201ZM10.794 10.5826L10.712 10.4356C10.3954 9.86758 10.237 9.58355 10.0003 9.58355C9.76361 9.58355 9.60528 9.86758 9.28862 10.4356L9.20669 10.5826C9.11671 10.744 9.07171 10.8247 9.00156 10.878C8.93141 10.9313 8.84404 10.951 8.6693 10.9906L8.51021 11.0266C7.89529 11.1657 7.58783 11.2353 7.51468 11.4705C7.44153 11.7057 7.65114 11.9508 8.07035 12.441L8.1788 12.5679C8.29793 12.7072 8.35749 12.7768 8.38429 12.863C8.41109 12.9491 8.40208 13.0421 8.38407 13.2279L8.36767 13.3971C8.3043 14.0512 8.27261 14.3782 8.46411 14.5236C8.65562 14.669 8.94349 14.5364 9.51924 14.2713L9.6682 14.2028C9.83181 14.1274 9.91361 14.0898 10.0003 14.0898C10.087 14.0898 10.1688 14.1274 10.3325 14.2028L10.4814 14.2713C11.0572 14.5364 11.345 14.669 11.5365 14.5236C11.728 14.3782 11.6964 14.0512 11.633 13.3971L11.6166 13.2279C11.5986 13.0421 11.5896 12.9491 11.6164 12.863C11.6432 12.7768 11.7027 12.7072 11.8218 12.5679L11.9303 12.441C12.3495 11.9508 12.5591 11.7057 12.486 11.4705C12.4128 11.2353 12.1054 11.1657 11.4904 11.0266L11.3314 10.9906C11.1566 10.951 11.0692 10.9313 10.9991 10.878C10.9289 10.8247 10.8839 10.744 10.794 10.5826Z",
        fill: "currentColor"
      }
    ]
  ],

  checkCircle: [
    [
      "path",
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M59.1663 31.9997C59.1663 46.7273 47.2273 58.6663 32.4997 58.6663C17.7721 58.6663 5.83301 46.7273 5.83301 31.9997C5.83301 17.2721 17.7721 5.33301 32.4997 5.33301C47.2273 5.33301 59.1663 17.2721 59.1663 31.9997ZM43.2472 23.9188C44.0283 24.6998 44.0283 25.9662 43.2472 26.7472L29.9139 40.0806C29.1328 40.8616 27.8665 40.8616 27.0855 40.0806L21.7521 34.7472C20.9711 33.9662 20.9711 32.6998 21.7521 31.9188C22.5332 31.1377 23.7995 31.1377 24.5806 31.9188L28.4997 35.8379L34.4592 29.8784L40.4188 23.9188C41.1998 23.1377 42.4662 23.1377 43.2472 23.9188Z",
        fill: "currentColor"
      }
    ]
  ],

  check: [
    [
      "path",
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M12.5831 5.51397C12.7911 5.69558 12.8125 6.01144 12.6309 6.21946L7.3928 12.2195C7.29785 12.3282 7.16052 12.3906 7.01614 12.3906C6.87177 12.3906 6.73444 12.3282 6.63949 12.2195L4.54425 9.81946C4.36264 9.61144 4.38405 9.29558 4.59208 9.11397C4.8001 8.93237 5.11596 8.95378 5.29756 9.1618L7.01614 11.1304L11.8776 5.5618C12.0592 5.35378 12.375 5.33237 12.5831 5.51397Z",
        fill: "currentColor"
      }
    ]
  ],

  checkCircleFilled: [
    [
      "path",
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM16.0303 8.96967C16.3232 9.26256 16.3232 9.73744 16.0303 10.0303L11.0303 15.0303C10.7374 15.3232 10.2626 15.3232 9.96967 15.0303L7.96967 13.0303C7.67678 12.7374 7.67678 12.2626 7.96967 11.9697C8.26256 11.6768 8.73744 11.6768 9.03033 11.9697L10.5 13.4393L12.7348 11.2045L14.9697 8.96967C15.2626 8.67678 15.7374 8.67678 16.0303 8.96967Z",
        fill: "currentColor"
      }
    ]
  ],

  closeCircleFilled: [
    [
      "path",
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM8.96963 8.96965C9.26252 8.67676 9.73739 8.67676 10.0303 8.96965L12 10.9393L13.9696 8.96967C14.2625 8.67678 14.7374 8.67678 15.0303 8.96967C15.3232 9.26256 15.3232 9.73744 15.0303 10.0303L13.0606 12L15.0303 13.9696C15.3232 14.2625 15.3232 14.7374 15.0303 15.0303C14.7374 15.3232 14.2625 15.3232 13.9696 15.0303L12 13.0607L10.0303 15.0303C9.73742 15.3232 9.26254 15.3232 8.96965 15.0303C8.67676 14.7374 8.67676 14.2625 8.96965 13.9697L10.9393 12L8.96963 10.0303C8.67673 9.73742 8.67673 9.26254 8.96963 8.96965Z",
        fill: "currentColor"
      }
    ]
  ],

  searchIcon: [
    [
      "path",
      {
        d: "M17.25 16.0833L13.75 12.5C14.5833 11.4167 15 10.1667 15 8.75C15 5.33333 12.1667 2.5 8.75 2.5C5.33333 2.5 2.5 5.33333 2.5 8.75C2.5 12.1667 5.33333 15 8.75 15C10.1667 15 11.5 14.5 12.5 13.75L16.0833 17.25C16.25 17.4167 16.5 17.5 16.6667 17.5C17.0833 17.5 17.5 17.0833 17.5 16.6667C17.5 16.4167 17.4167 16.25 17.25 16.0833ZM8.75 13.3333C6.25 13.3333 4.16667 11.25 4.16667 8.75C4.16667 6.25 6.25 4.16667 8.75 4.16667C11.25 4.16667 13.3333 6.25 13.3333 8.75C13.3333 11.25 11.25 13.3333 8.75 13.3333Z",
        fill: "currentColor",
        stroke: "none"
      }
    ]
  ],

  filterIcon: [
    [
      "path",
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M18.9583 5.83334C18.9583 6.17852 18.6785 6.45834 18.3333 6.45834L1.66668 6.45834C1.3215 6.45834 1.04168 6.17852 1.04168 5.83334C1.04168 5.48817 1.3215 5.20834 1.66668 5.20834L18.3333 5.20834C18.6785 5.20834 18.9583 5.48817 18.9583 5.83334Z",
        fill: "currentColor",
        stroke: "none"
      }
    ],
    [
      "path",
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M16.4583 10C16.4583 10.3452 16.1785 10.625 15.8333 10.625L4.16668 10.625C3.8215 10.625 3.54168 10.3452 3.54168 10C3.54168 9.65482 3.8215 9.375 4.16668 9.375L15.8333 9.375C16.1785 9.375 16.4583 9.65482 16.4583 10Z",
        fill: "currentColor",
        stroke: "none"
      }
    ],
    [
      "path",
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M13.9583 14.1667C13.9583 14.5118 13.6785 14.7917 13.3333 14.7917L6.66668 14.7917C6.3215 14.7917 6.04168 14.5118 6.04168 14.1667C6.04168 13.8215 6.3215 13.5417 6.66668 13.5417H13.3333C13.6785 13.5417 13.9583 13.8215 13.9583 14.1667Z",
        fill: "currentColor",
        stroke: "none"
      }
    ]
  ],

  fileText: [
    [
      "path",
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M11.667 18.3333H8.33366C5.19096 18.3333 3.61961 18.3333 2.6433 17.357C1.66699 16.3807 1.66699 14.8093 1.66699 11.6666V8.33329C1.66699 5.1906 1.66699 3.61925 2.6433 2.64294C3.61961 1.66663 5.19924 1.66663 8.35849 1.66663C8.86349 1.66663 9.26816 1.66663 9.60866 1.68051C9.59746 1.74712 9.59158 1.81507 9.59135 1.88376L9.58365 4.24577C9.58358 5.16002 9.58352 5.96799 9.67108 6.61926C9.76599 7.32519 9.98391 8.03101 10.56 8.60707C11.136 9.18313 11.8419 9.40105 12.5478 9.49596C13.199 9.58352 14.007 9.58346 14.9213 9.58339L15.0003 9.58338H18.2982C18.3337 10.0286 18.3337 10.575 18.3337 11.3024V11.6666C18.3337 14.8093 18.3337 16.3807 17.3573 17.357C16.381 18.3333 14.8097 18.3333 11.667 18.3333ZM4.37533 12.0833C4.37533 11.7381 4.65515 11.4583 5.00033 11.4583H11.667C12.0122 11.4583 12.292 11.7381 12.292 12.0833C12.292 12.4285 12.0122 12.7083 11.667 12.7083H5.00033C4.65515 12.7083 4.37533 12.4285 4.37533 12.0833ZM4.37533 15C4.37533 14.6548 4.65515 14.375 5.00033 14.375H9.58366C9.92884 14.375 10.2087 14.6548 10.2087 15C10.2087 15.3451 9.92884 15.625 9.58366 15.625H5.00033C4.65515 15.625 4.37533 15.3451 4.37533 15Z",
        fill: "currentColor",
        stroke: "none"
      }
    ],
    [
      "path",
      {
        d: "M16.1268 6.34717L12.8278 3.37809C11.8879 2.53219 11.418 2.10925 10.8413 1.88798L10.8337 4.16671C10.8337 6.1309 10.8337 7.11299 11.4439 7.72319C12.054 8.33338 13.0361 8.33338 15.0003 8.33338H17.9837C17.6816 7.74653 17.1406 7.25966 16.1268 6.34717Z",
        fill: "currentColor",
        stroke: "none"
      }
    ]
  ],

  pen: [
    [
      "path",
      {
        d: "M6.81143 12.85C7.02355 12.6846 7.21596 12.4922 7.60072 12.1074L12.5313 7.17686C11.8602 6.89756 11.0654 6.43878 10.3138 5.6871C9.56195 4.9353 9.10315 4.14037 8.82386 3.46925L3.8932 8.39991L3.89317 8.39994C3.50842 8.78469 3.31603 8.97708 3.15058 9.1892C2.95541 9.43943 2.78807 9.71019 2.65155 9.99666C2.53581 10.2395 2.44977 10.4976 2.27769 11.0139L1.37028 13.7361C1.2856 13.9901 1.35172 14.2702 1.54107 14.4596C1.73042 14.6489 2.0105 14.715 2.26455 14.6303L4.98677 13.7229C5.50299 13.5509 5.76112 13.4648 6.00397 13.3491C6.29044 13.2126 6.56119 13.0452 6.81143 12.85Z",
        fill: "currentColor"
      }
    ],
    [
      "path",
      {
        d: "M13.8995 5.80868C14.9233 4.78488 14.9233 3.12497 13.8995 2.10116C12.8757 1.07736 11.2157 1.07736 10.1919 2.10116L9.60059 2.69252C9.60868 2.71698 9.61708 2.74177 9.6258 2.76688C9.84255 3.39164 10.2515 4.21065 11.0209 4.97999C11.7902 5.74934 12.6092 6.1583 13.234 6.37506C13.259 6.38373 13.2836 6.39209 13.308 6.40015L13.8995 5.80868Z",
        fill: "currentColor"
      }
    ]
  ],

  forward: [
    [
      "path",
      {
        d: "M9.30305 3.45571L12.6216 6.40554C13.242 6.95699 13.5522 7.23271 13.6665 7.5583C13.7669 7.84422 13.7669 8.1558 13.6665 8.44172C13.5522 8.7673 13.242 9.04303 12.6216 9.59448L9.30305 12.5443C9.02152 12.7946 8.88076 12.9197 8.76119 12.9242C8.65732 12.928 8.55758 12.8833 8.49148 12.803C8.41539 12.7107 8.41539 12.5224 8.41539 12.1457V10.2857C6.79667 10.2857 5.08696 10.8056 3.83855 11.7285C3.18862 12.209 2.86364 12.4492 2.73987 12.4398C2.61922 12.4305 2.54265 12.3834 2.48005 12.2799C2.41583 12.1736 2.47255 11.8417 2.586 11.1778C3.32265 6.86705 6.2893 5.71429 8.41539 5.71429V3.85433C8.41539 3.47765 8.41539 3.28931 8.49148 3.19697C8.55758 3.11676 8.65732 3.07197 8.76119 3.07586C8.88076 3.08033 9.02152 3.20546 9.30305 3.45571Z",
        fill: "currentColor"
      }
    ]
  ],

  inboxIn: [
    [
      "path",
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M8.00065 7.16665C8.13326 7.16665 8.26044 7.11397 8.3542 7.0202L10.3542 5.0202C10.5495 4.82494 10.5495 4.50835 10.3542 4.31309C10.1589 4.11783 9.84236 4.11783 9.6471 4.31309L8.50065 5.45954V1.33331C8.50065 1.05717 8.27679 0.833313 8.00065 0.833313C7.72451 0.833313 7.50065 1.05717 7.50065 1.33331V5.45954L6.3542 4.31309C6.15894 4.11783 5.84236 4.11783 5.6471 4.31309C5.45184 4.50836 5.45184 4.82494 5.6471 5.0202L7.6471 7.0202C7.74087 7.11397 7.86804 7.16665 8.00065 7.16665Z",
        fill: "currentColor"
      }
    ],
    [
      "path",
      {
        d: "M2.3103 13.6903C3.28661 14.6666 4.85795 14.6666 8.00065 14.6666C11.1433 14.6666 12.7147 14.6666 13.691 13.6903C14.5382 12.8431 14.6502 11.5479 14.6651 9.16665H12.5605C11.9113 9.16665 11.7415 9.17734 11.599 9.24288C11.4565 9.30843 11.3379 9.43035 10.9154 9.92326L10.4536 10.4622C10.1188 10.8535 9.85373 11.1635 9.48681 11.3323C9.11989 11.501 8.71202 11.5006 8.19701 11.5H7.80429C7.28928 11.5006 6.88141 11.501 6.51449 11.3323C6.14757 11.1635 5.88246 10.8535 5.54771 10.4622L5.08588 9.92326C4.66338 9.43035 4.5448 9.30843 4.40229 9.24288C4.25977 9.17734 4.09003 9.16665 3.44082 9.16665H1.33624C1.35106 11.5479 1.4631 12.8431 2.3103 13.6903Z",
        fill: "currentColor"
      }
    ],
    [
      "path",
      {
        d: "M14.6673 7.99998C14.6673 4.85728 14.6673 3.28593 13.691 2.30962C12.8842 1.50283 11.6711 1.36275 9.50065 1.33842V3.25206C10.0283 3.06597 10.6393 3.18395 11.0613 3.60598C11.6471 4.19177 11.6471 5.14152 11.0613 5.72731L9.06131 7.72731C8.78001 8.00861 8.39848 8.16665 8.00065 8.16665C7.60283 8.16665 7.22129 8.00861 6.93999 7.72731L4.93999 5.72731C4.3542 5.14152 4.3542 4.19177 4.93999 3.60599C5.36203 3.18395 5.97299 3.06597 6.50065 3.25206V1.33842C4.33022 1.36275 3.11709 1.50283 2.3103 2.30962C1.33398 3.28593 1.33398 4.85728 1.33398 7.99998L1.33399 8.16665L3.53034 8.16658C4.04535 8.16604 4.45322 8.16561 4.82014 8.33437C5.18706 8.50313 5.45218 8.81309 5.78693 9.20446L6.24875 9.74336C6.67125 10.2363 6.78984 10.3582 6.93235 10.4237C7.07486 10.4893 7.24461 10.5 7.89381 10.5H8.10749C8.7567 10.5 8.92644 10.4893 9.06895 10.4237C9.21146 10.3582 9.33005 10.2363 9.75255 9.74336L10.2144 9.20446C10.5491 8.81309 10.8142 8.50313 11.1812 8.33437C11.5481 8.16561 11.956 8.16604 12.471 8.16658L14.6673 8.16665L14.6673 7.99998Z",
        fill: "currentColor"
      }
    ]
  ],

  global: [
    [
      "path",
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M1.35156 7.49998C1.60725 4.05161 4.48606 1.33331 7.99976 1.33331C7.44585 1.33331 6.95268 1.57612 6.54696 1.9474C6.14328 2.31681 5.80215 2.8325 5.52623 3.44208C5.24868 4.05526 5.0331 4.77243 4.88718 5.55072C4.77021 6.17461 4.69903 6.83232 4.6753 7.49998H1.35156ZM1.35156 8.49998H4.6753C4.69903 9.16764 4.77021 9.82535 4.88718 10.4492C5.0331 11.2275 5.24868 11.9447 5.52623 12.5579C5.80215 13.1675 6.14328 13.6831 6.54696 14.0526C6.95268 14.4238 7.44585 14.6666 7.99976 14.6666C4.48606 14.6666 1.60725 11.9483 1.35156 8.49998Z",
        fill: "currentColor"
      }
    ],
    [
      "path",
      {
        d: "M7.99976 2.26355C7.81642 2.26355 7.57957 2.34156 7.30416 2.59359C7.02672 2.84749 6.74897 3.24541 6.50357 3.78756C6.25981 4.32612 6.06187 4.97625 5.92565 5.70278C5.81838 6.27493 5.75184 6.88144 5.72848 7.49998H10.271C10.2477 6.88144 10.1811 6.27493 10.0739 5.70278C9.93766 4.97625 9.73972 4.32612 9.49595 3.78756C9.25056 3.24541 8.97281 2.84749 8.69536 2.59359C8.41995 2.34156 8.1831 2.26355 7.99976 2.26355Z",
        fill: "currentColor"
      }
    ],
    [
      "path",
      {
        d: "M5.92565 10.2972C6.06187 11.0237 6.25981 11.6738 6.50357 12.2124C6.74897 12.7545 7.02672 13.1525 7.30416 13.4064C7.57957 13.6584 7.81642 13.7364 7.99976 13.7364C8.1831 13.7364 8.41995 13.6584 8.69536 13.4064C8.97281 13.1525 9.25056 12.7545 9.49595 12.2124C9.73972 11.6738 9.93766 11.0237 10.0739 10.2972C10.1811 9.72503 10.2477 9.11852 10.271 8.49998H5.72848C5.75184 9.11852 5.81838 9.72503 5.92565 10.2972Z",
        fill: "currentColor"
      }
    ],
    [
      "path",
      {
        d: "M7.99976 1.33331C8.55367 1.33331 9.04685 1.57612 9.45256 1.9474C9.85624 2.31682 10.1974 2.8325 10.4733 3.44208C10.7508 4.05526 10.9664 4.77243 11.1123 5.55072C11.2293 6.17461 11.3005 6.83232 11.3242 7.49998H14.648C14.3923 4.05161 11.5135 1.33331 7.99976 1.33331Z",
        fill: "currentColor"
      }
    ],
    [
      "path",
      {
        d: "M11.1123 10.4492C10.9664 11.2275 10.7508 11.9447 10.4733 12.5579C10.1974 13.1675 9.85624 13.6831 9.45256 14.0526C9.04685 14.4238 8.55367 14.6666 7.99976 14.6666C11.5135 14.6666 14.3923 11.9483 14.648 8.49998H11.3242C11.3005 9.16764 11.2293 9.82535 11.1123 10.4492Z",
        fill: "currentColor"
      }
    ]
  ],

  trashBin: [
    [
      "path",
      {
        d: "M2 4.34919C2 4.08619 2.21781 3.873 2.48648 3.873H5.67858C5.68292 3.31218 5.7437 2.54334 6.30025 2.0111C6.73824 1.59224 7.33872 1.33331 7.99999 1.33331C8.66127 1.33331 9.26174 1.59224 9.69974 2.0111C10.2563 2.54334 10.3171 3.31218 10.3214 3.873H13.5135C13.7822 3.873 14 4.08619 14 4.34919C14 4.61218 13.7822 4.82538 13.5135 4.82538H2.48648C2.21781 4.82538 2 4.61218 2 4.34919Z",
        fill: "currentColor"
      }
    ],
    [
      "path",
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M7.7304 14.6666H8.2696C10.1247 14.6666 11.0523 14.6666 11.6554 14.076C12.2585 13.4854 12.3202 12.5166 12.4436 10.579L12.6214 7.78705C12.6884 6.73572 12.7219 6.21005 12.4193 5.87695C12.1167 5.54384 11.6058 5.54384 10.584 5.54384H5.41603C4.39418 5.54384 3.88325 5.54384 3.5807 5.87695C3.27815 6.21005 3.31163 6.73572 3.37858 7.78705L3.55639 10.579C3.6798 12.5166 3.7415 13.4854 4.34459 14.076C4.94769 14.6666 5.87526 14.6666 7.7304 14.6666ZM6.83085 8.12563C6.80337 7.8364 6.55835 7.62537 6.28358 7.6543C6.00881 7.68322 5.80834 7.94114 5.83581 8.23037L6.16915 11.7391C6.19662 12.0284 6.44165 12.2394 6.71642 12.2105C6.99119 12.1816 7.19166 11.9236 7.16419 11.6344L6.83085 8.12563ZM9.71642 7.6543C9.99119 7.68322 10.1917 7.94114 10.1642 8.23037L9.83085 11.7391C9.80338 12.0284 9.55835 12.2394 9.28358 12.2105C9.00881 12.1816 8.80834 11.9236 8.83581 11.6344L9.16915 8.12563C9.19663 7.8364 9.44165 7.62537 9.71642 7.6543Z",
        fill: "currentColor"
      }
    ]
  ],

  menuDots: [
    [
      "path",
      {
        d: "M10.0007 14.1667C10.9211 14.1667 11.6673 14.9129 11.6673 15.8333C11.6673 16.7538 10.9211 17.5 10.0007 17.5C9.08018 17.5 8.33398 16.7538 8.33398 15.8333C8.33398 14.9129 9.08018 14.1667 10.0007 14.1667Z",
        fill: "currentColor"
      }
    ],
    [
      "path",
      {
        d: "M10.0007 8.33333C10.9211 8.33333 11.6673 9.07953 11.6673 10C11.6673 10.9205 10.9211 11.6667 10.0007 11.6667C9.08018 11.6667 8.33398 10.9205 8.33398 10C8.33398 9.07953 9.08018 8.33333 10.0007 8.33333Z",
        fill: "currentColor"
      }
    ],
    [
      "path",
      {
        d: "M10.0007 2.5C10.9211 2.5 11.6673 3.24619 11.6673 4.16667C11.6673 5.08714 10.9211 5.83333 10.0007 5.83333C9.08018 5.83333 8.33398 5.08714 8.33398 4.16667C8.33398 3.24619 9.08018 2.5 10.0007 2.5Z",
        fill: "currentColor"
      }
    ]
  ],

  link: [
    [
      "path",
      {
        d: "M10.47,5.52A0.5,0.5,0,0,1,10.47,6.23L6.23,10.47A0.5,0.5,0,0,1,5.52,9.77l4.24-4.24A0.5,0.5,0,0,1,10.47,5.52ZM8.71,10.83L6.94,12.6A2.5,2.5,0,1,1,3.4,9.06l1.77-1.77a0.5,0.5,0,1,0-0.71-0.71L2.7,8.35a3.5,3.5,0,0,0,4.95,4.95l1.77-1.77a0.5,0.5,0,0,0-0.71-0.71ZM13.3,2.7a3.5,3.5,0,0,0-4.95,0L6.59,4.46a0.5,0.5,0,0,0,0.71,0.71l1.77-1.77a2.5,2.5,0,0,1,3.54,3.54l-1.77,1.77a0.5,0.5,0,0,0,0.71,0.71l1.77-1.77A3.5,3.5,0,0,0,13.3,2.7Z",
        fill: "currentColor"
      }
    ]
  ],

  generate: [
    [
      "path",
      {
        d: "M5.36616 3.19508C5.59089 2.26832 6.90895 2.26832 7.13368 3.19508L7.75202 5.74512C7.83226 6.076 8.0906 6.33434 8.42148 6.41457L10.9715 7.03292C11.8983 7.25765 11.8983 8.57571 10.9715 8.80043L8.42148 9.41878C8.0906 9.49901 7.83226 9.75736 7.75202 10.0882L7.13368 12.6383C6.90895 13.565 5.59089 13.565 5.36616 12.6383L4.74782 10.0882C4.66758 9.75736 4.40924 9.49901 4.07836 9.41878L1.52832 8.80043C0.601563 8.57571 0.601562 7.25765 1.52832 7.03292L4.07836 6.41458C4.40924 6.33434 4.66758 6.076 4.74782 5.74512L5.36616 3.19508Z",
        fill: "currentColor"
      }
    ],
    [
      "path",
      {
        d: "M12.7894 12.0944C12.9277 11.5241 13.7388 11.5241 13.8771 12.0944L14.2576 13.6637C14.307 13.8673 14.466 14.0263 14.6696 14.0756L16.2389 14.4562C16.8092 14.5945 16.8092 15.4056 16.2389 15.5439L14.6696 15.9244C14.466 15.9738 14.307 16.1327 14.2576 16.3364L13.8771 17.9056C13.7388 18.4759 12.9277 18.4759 12.7894 17.9056L12.4089 16.3364C12.3595 16.1327 12.2005 15.9738 11.9969 15.9244L10.4277 15.5439C9.85734 15.4056 9.85734 14.5945 10.4277 14.4562L11.9969 14.0756C12.2005 14.0263 12.3595 13.8673 12.4089 13.6637L12.7894 12.0944Z",
        fill: "currentColor"
      }
    ],
    [
      "path",
      {
        d: "M15.4764 3.09321C15.5671 2.71894 16.0994 2.71894 16.1902 3.09321L16.4399 4.12303C16.4723 4.25666 16.5766 4.36099 16.7102 4.39339L17.7401 4.64311C18.1143 4.73386 18.1143 5.26616 17.7401 5.35691L16.7102 5.60663C16.5766 5.63903 16.4723 5.74336 16.4399 5.87699L16.1902 6.90681C16.0994 7.28108 15.5671 7.28108 15.4764 6.90681L15.2266 5.87699C15.1942 5.74336 15.0899 5.63903 14.9563 5.60663L13.9265 5.35691C13.5522 5.26616 13.5522 4.73386 13.9265 4.64311L14.9563 4.39339C15.0899 4.36099 15.1942 4.25666 15.2266 4.12303L15.4764 3.09321Z",
        fill: "currentColor"
      }
    ],
    [
      "path",
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M15.8333 3.27592L15.6294 4.11644C15.548 4.45241 15.2857 4.71473 14.9497 4.7962L14.1092 5.00001L14.9497 5.20382C15.2857 5.28529 15.548 5.54761 15.6294 5.88358L15.8333 6.7241L16.0371 5.88358C16.1185 5.54761 16.3809 5.28529 16.7168 5.20382L17.5573 5.00001L16.7168 4.7962C16.3809 4.71473 16.1185 4.45241 16.0371 4.11644L15.8333 3.27592ZM16.2411 2.82081C16.1374 2.39308 15.5291 2.39308 15.4254 2.82081L15.14 3.99775C15.1029 4.15047 14.9837 4.2697 14.831 4.30673L13.6541 4.59212C13.2263 4.69584 13.2263 5.30418 13.6541 5.4079L14.831 5.69329C14.9837 5.73032 15.1029 5.84956 15.14 6.00227L15.4254 7.17921C15.5291 7.60694 16.1374 7.60694 16.2411 7.17921L16.5265 6.00227C16.5636 5.84956 16.6828 5.73032 16.8355 5.69329L18.0125 5.4079C18.4402 5.30418 18.4402 4.69584 18.0125 4.59212L16.8355 4.30673C16.6828 4.2697 16.5636 4.15047 16.5265 3.99775L16.2411 2.82081Z",
        fill: "currentColor"
      }
    ],
    [
      "path",
      {
        d: "M5.83325 19.1667C5.37301 19.1667 4.99992 18.7936 4.99992 18.3333C4.99992 17.8731 5.37301 17.5 5.83325 17.5C6.29349 17.5 6.66659 17.8731 6.66659 18.3333C6.66659 18.7936 6.29349 19.1667 5.83325 19.1667Z",
        fill: "currentColor"
      }
    ],
    [
      "path",
      {
        d: "M1.66659 15.8333C1.20635 15.8333 0.833252 15.4602 0.833252 15C0.833252 14.5398 1.20635 14.1667 1.66659 14.1667C2.12682 14.1667 2.49992 14.5398 2.49992 15C2.49992 15.4602 2.12682 15.8333 1.66659 15.8333Z",
        fill: "currentColor"
      }
    ],
    [
      "path",
      {
        d: "M10.8333 2.50001C10.373 2.50001 9.99992 2.12691 9.99992 1.66668C9.99992 1.20644 10.373 0.833343 10.8333 0.833344C11.2935 0.833344 11.6666 1.20644 11.6666 1.66668C11.6666 2.12691 11.2935 2.50001 10.8333 2.50001Z",
        fill: "currentColor"
      }
    ],
    [
      "path",
      {
        d: "M18.3333 11.6667C17.873 11.6667 17.4999 11.2936 17.4999 10.8333C17.4999 10.3731 17.873 10 18.3333 10C18.7935 10 19.1666 10.3731 19.1666 10.8333C19.1666 11.2936 18.7935 11.6667 18.3333 11.6667Z",
        fill: "currentColor"
      }
    ]
  ],

  upload: [
    [
      "path",
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M8.49992 10.4999C8.77606 10.4999 8.99992 10.2761 8.99992 9.99992V2.68488L10.1203 3.99198C10.3 4.20164 10.6157 4.22592 10.8253 4.04621C11.035 3.8665 11.0593 3.55085 10.8795 3.34119L8.87955 1.00786C8.78456 0.897033 8.64588 0.833252 8.49992 0.833252C8.35396 0.833252 8.21528 0.897033 8.12029 1.00786L6.12029 3.34119C5.94058 3.55085 5.96486 3.8665 6.17452 4.04621C6.38419 4.22592 6.69984 4.20164 6.87955 3.99198L7.99992 2.68488L7.99992 9.99992C7.99992 10.2761 8.22378 10.4999 8.49992 10.4999Z",
        fill: "currentColor"
      }
    ],
    [
      "path",
      {
        d: "M11.1666 5.99992C10.6985 5.99992 10.4644 5.99992 10.2963 6.11226C10.2234 6.1609 10.1609 6.22342 10.1123 6.29622C9.99995 6.46437 9.99995 6.69843 9.99995 7.16656L9.99994 9.99992C9.99994 10.8283 9.32837 11.4999 8.49994 11.4999C7.67152 11.4999 6.99995 10.8283 6.99995 9.99992L6.99995 7.16661C6.99995 6.69843 6.99995 6.46434 6.88758 6.29619C6.83895 6.22341 6.77646 6.16092 6.70368 6.11228C6.53552 5.99992 6.30143 5.99992 5.83325 5.99992C3.94763 5.99992 3.00482 5.99992 2.41904 6.5857C1.83325 7.17149 1.83325 8.11415 1.83325 9.99977V10.6664C1.83325 12.5521 1.83325 13.4949 2.41904 14.0806C3.00482 14.6664 3.94763 14.6664 5.83325 14.6664H11.1666C13.0522 14.6664 13.995 14.6664 14.5808 14.0807C15.1666 13.4949 15.1666 12.5521 15.1666 10.6664V9.99977C15.1666 8.11415 15.1666 7.17149 14.5808 6.5857C13.995 5.99992 13.0522 5.99992 11.1666 5.99992Z",
        fill: "currentColor"
      }
    ]
  ],

  refresh: [
    [
      "path",
      {
        d: "M8.55251 1.5C5.35685 1.5 2.72977 3.942 2.47362 7.05556H1.83327C1.63068 7.05556 1.44811 7.1778 1.37095 7.36512C1.29379 7.55244 1.33729 7.76781 1.48111 7.9105L2.60098 9.02161C2.79592 9.21502 3.11036 9.21502 3.3053 9.02161L4.42518 7.9105C4.56899 7.76781 4.61249 7.55244 4.53533 7.36512C4.45817 7.1778 4.2756 7.05556 4.07302 7.05556H3.47779C3.73093 4.50111 5.90311 2.5 8.55251 2.5C10.3989 2.5 12.0151 3.4723 12.9103 4.92853C13.0549 5.16377 13.3629 5.23723 13.5981 5.09261C13.8334 4.94799 13.9068 4.64005 13.7622 4.40481C12.6913 2.66285 10.7581 1.5 8.55251 1.5Z",
        fill: "currentColor"
      }
    ],
    [
      "path",
      {
        d: "M14.394 6.97772C14.1992 6.7852 13.8858 6.7852 13.691 6.97772L12.5669 8.08883C12.4227 8.23137 12.3788 8.44688 12.4559 8.63444C12.5329 8.82199 12.7156 8.94445 12.9184 8.94445H13.5178C13.2636 11.4975 11.0839 13.5 8.42175 13.5C6.56676 13.5 4.94383 12.5269 4.04522 11.0708C3.9002 10.8358 3.59214 10.7628 3.35714 10.9078C3.12214 11.0529 3.0492 11.3609 3.19423 11.5959C4.2693 13.338 6.20929 14.5 8.42175 14.5C11.627 14.5 14.2649 12.0595 14.522 8.94445H15.1667C15.3695 8.94445 15.5521 8.82199 15.6292 8.63444C15.7062 8.44688 15.6624 8.23137 15.5182 8.08883L14.394 6.97772Z",
        fill: "currentColor"
      }
    ]
  ],

  sendMessage: [
    [
      "path",
      {
        d: "M8 6L12 2L16 6",
        stroke: "currentColor",
        "stroke-width": "3",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        fill: "none"
      }
    ],
    [
      "path",
      {
        d: "M12 2V22",
        stroke: "currentColor",
        "stroke-width": "3",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        fill: "none"
      }
    ]
  ],

  square: [
    [
      "path",
      {
        d: "M5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3Z",
        fill: "currentColor",
        stroke: "none"
      }
    ]
  ],

  star: [
    [
      "path",
      {
        d: "M6.10209 3.60562C6.94652 2.09079 7.36874 1.33337 7.99998 1.33337C8.63122 1.33337 9.05344 2.09079 9.89787 3.60562L10.1163 3.99753C10.3563 4.428 10.4763 4.64323 10.6634 4.78524C10.8504 4.92726 11.0834 4.97997 11.5494 5.08541L11.9736 5.18139C13.6134 5.55241 14.4333 5.73792 14.6284 6.36519C14.8234 6.99247 14.2645 7.64609 13.1466 8.95332L12.8574 9.29152C12.5397 9.663 12.3809 9.84873 12.3094 10.0785C12.2379 10.3083 12.262 10.5561 12.31 11.0517L12.3537 11.503C12.5227 13.2471 12.6072 14.1192 12.0965 14.5069C11.5859 14.8945 10.8182 14.5411 9.28286 13.8342L8.88566 13.6513C8.44936 13.4504 8.23122 13.3499 7.99998 13.3499C7.76874 13.3499 7.5506 13.4504 7.1143 13.6513L6.7171 13.8342C5.18176 14.5411 4.4141 14.8945 3.90341 14.5069C3.39273 14.1192 3.47723 13.2471 3.64624 11.503L3.68997 11.0517C3.738 10.5561 3.76201 10.3083 3.69055 10.0785C3.6191 9.84873 3.46026 9.663 3.14259 9.29152L2.85338 8.95332C1.73548 7.64609 1.17653 6.99247 1.37159 6.36519C1.56666 5.73792 2.38655 5.55241 4.02634 5.18139L4.45057 5.08541C4.91655 4.97997 5.14953 4.92726 5.33661 4.78524C5.52368 4.64323 5.64366 4.428 5.88362 3.99753L6.10209 3.60562Z",
        fill: "currentColor"
      }
    ]
  ],

  copy: [
    [
      "path",
      {
        d: "M10.16 1.33337H7.56389C6.38773 1.33336 5.45612 1.33336 4.72703 1.43177C3.97668 1.53306 3.36935 1.74647 2.8904 2.22735C2.41144 2.70822 2.19889 3.31799 2.09801 4.07135C1.99998 4.80338 1.99999 5.73872 2 6.9196V10.8113C2 11.8167 2.6133 12.6783 3.48478 13.0395C3.43992 12.4332 3.43996 11.5825 3.44 10.8747L3.44 7.59843L3.44 7.53498C3.43995 6.68054 3.43991 5.94433 3.51886 5.35478C3.60346 4.72296 3.79426 4.11732 4.28353 3.62608C4.77281 3.13484 5.37603 2.94328 6.00532 2.85833C6.59251 2.77907 7.32578 2.77911 8.1768 2.77916L8.24 2.77916H10.16L10.2232 2.77916C11.0742 2.77911 11.8059 2.77907 12.3931 2.85833C12.0418 1.96523 11.1744 1.33337 10.16 1.33337Z",
        fill: "currentColor"
      }
    ],
    [
      "path",
      {
        d: "M4.40009 7.59822C4.40009 5.78076 4.40009 4.87202 4.96244 4.30741C5.5248 3.7428 6.42989 3.7428 8.24009 3.7428H10.1601C11.9703 3.7428 12.8754 3.7428 13.4377 4.30741C14.0001 4.87202 14.0001 5.78076 14.0001 7.59822V10.8111C14.0001 12.6285 14.0001 13.5373 13.4377 14.1019C12.8754 14.6665 11.9703 14.6665 10.1601 14.6665H8.24008C6.42989 14.6665 5.5248 14.6665 4.96244 14.1019C4.40009 13.5373 4.40009 12.6285 4.40009 10.8111V7.59822Z",
        fill: "currentColor"
      }
    ]
  ],

  restartCircle: [
    [
      "path",
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M6.66667 13.3333C10.3486 13.3333 13.3333 10.3486 13.3333 6.66667C13.3333 2.98477 10.3486 0 6.66667 0C2.98477 0 0 2.98477 0 6.66667C0 10.3486 2.98477 13.3333 6.66667 13.3333ZM9.28975 2.39439C9.47802 2.47108 9.60111 2.65414 9.60111 2.85744V4.66712C9.60111 4.94326 9.37726 5.16712 9.10111 5.16712H7.33335C7.13218 5.16712 6.95061 5.04656 6.87254 4.86116C6.79447 4.67576 6.83511 4.46163 6.97568 4.31773L7.48334 3.79803C6.51966 3.50095 5.43116 3.74202 4.66732 4.52398C3.55534 5.66231 3.55534 7.51267 4.66732 8.65101C5.7729 9.7828 7.56044 9.7828 8.66602 8.65101C9.1179 8.18841 9.38703 7.6075 9.47127 7.00298C9.5101 6.72435 9.73146 6.48996 10.0128 6.48996C10.2831 6.48996 10.5073 6.70633 10.4812 6.97536C10.3971 7.84042 10.0314 8.68433 9.38136 9.34978C7.88345 10.8832 5.44989 10.8832 3.95197 9.34978C2.46045 7.8229 2.46045 5.35208 3.95197 3.8252C5.11034 2.63937 6.82934 2.36977 8.24311 3.02025L8.74344 2.50805C8.8855 2.36262 9.10147 2.31769 9.28975 2.39439Z",
        fill: "currentColor"
      }
    ]
  ],

  addImage: [
    [
      "path",
      {
        d: "M5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        fill: "none"
      }
    ],
    [
      "path",
      {
        d: "M11 9C11 10.1046 10.1046 11 9 11C7.89543 11 7 10.1046 7 9C7 7.89543 7.89543 7 9 7C10.1046 7 11 7.89543 11 9Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        fill: "none"
      }
    ],
    [
      "path",
      {
        d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        fill: "none"
      }
    ]
  ],

  importSheet: [
    [
      "path",
      {
        d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        fill: "none"
      }
    ],
    [
      "path",
      {
        d: "M14 2v4a2 2 0 0 0 2 2h4",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        fill: "none"
      }
    ],
    [
      "path",
      {
        d: "M12 18v-6",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        fill: "none"
      }
    ],
    [
      "path",
      {
        d: "m9 15 3 3 3-3",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        fill: "none"
      }
    ]
  ],

  folder: [
    [
      "path",
      {
        d: "M0.723807 3.38183C0.666016 3.68813 0.666016 4.05585 0.666016 4.79129V6.70817H17.2936C17.2334 5.83415 17.0804 5.26047 16.6915 4.82803C16.6325 4.76245 16.5701 4.70004 16.5045 4.64106C15.7916 3.99984 14.6947 3.99984 12.5011 3.99984H12.1897C11.2283 3.99984 10.7476 3.99984 10.2996 3.87215C10.0536 3.80201 9.81638 3.70376 9.59278 3.57936C9.18574 3.3529 8.84583 3.01299 8.16602 2.33317L7.70747 1.87463C7.47962 1.64678 7.36569 1.53285 7.24597 1.4336C6.72978 1.0057 6.09656 0.743409 5.42899 0.680983C5.27415 0.666504 5.11304 0.666504 4.79081 0.666504C4.05536 0.666504 3.68764 0.666504 3.38134 0.724296C2.03294 0.978704 0.978216 2.03343 0.723807 3.38183ZM17.3308 7.95817H0.666016V10.6665C0.666016 13.8092 0.666016 15.3805 1.64233 16.3569C2.61864 17.3332 4.18999 17.3332 7.33268 17.3332H10.666C13.8087 17.3332 15.3801 17.3332 16.3564 16.3569C17.3327 15.3805 17.3327 13.8092 17.3327 10.6665V8.83142C17.3327 8.51874 17.3308 7.95817 17.3308 7.95817Z",
        fill: "currentColor"
      }
    ]
  ],

  chevronDown: [
    [
      "path",
      {
        d: "M0.5 1.5C0.5 0.95 0.95 0.5 1.5 0.5C1.76 0.5 2.02 0.6 2.21 0.8C3.16 1.76 6 4.65 6 4.65C6 4.65 8.84 1.76 9.79 0.8C9.99 0.6 10.24 0.5 10.5 0.5C11.05 0.5 11.5 0.95 11.5 1.5C11.5 1.75 11.4 2.01 11.21 2.2C9.91 3.53 6 7.5 6 7.5C6 7.5 2.09 3.53 0.790001 2.2C0.600001 2.01 0.5 1.75 0.5 1.5Z",
        fill: "currentColor"
      }
    ]
  ],

  save: [
    [
      "path",
      {
        d: "M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        fill: "none"
      }
    ],
    [
      "path",
      {
        d: "M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        fill: "none"
      }
    ],
    [
      "path",
      {
        d: "M7 3v4a1 1 0 0 0 1 1h7",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        fill: "none"
      }
    ]
  ],

  sidebarMinimize: [
    [
      "path",
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M2.64297 3.47631C1.66666 4.45262 1.66666 6.02397 1.66666 9.16667V10.8333C1.66666 13.976 1.66666 15.5474 2.64297 16.5237C3.61928 17.5 5.19063 17.5 8.33332 17.5H11.6667C11.7369 17.5 11.8063 17.5 11.875 17.5L11.875 2.5C11.8063 2.49999 11.7369 2.5 11.6667 2.5H8.33332C5.19063 2.5 3.61928 2.5 2.64297 3.47631ZM13.125 2.50466L13.125 17.4953C15.3216 17.4723 16.5451 17.3356 17.357 16.5237C18.3333 15.5474 18.3333 13.976 18.3333 10.8333V9.16667C18.3333 6.02397 18.3333 4.45262 17.357 3.47631C16.5451 2.66437 15.3216 2.52767 13.125 2.50466Z",
        fill: "currentColor"
      }
    ]
  ],

  table: [
    [
      "path",
      {
        d: "M12 3v18",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        fill: "none"
      }
    ],
    [
      "path",
      {
        d: "M5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        fill: "none"
      }
    ],
    [
      "path",
      {
        d: "M3 9h18",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        fill: "none"
      }
    ],
    [
      "path",
      {
        d: "M3 15h18",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        fill: "none"
      }
    ]
  ],

  roleWheel: [
    [
      "path",
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M9.99984 18.3337C14.6022 18.3337 18.3332 14.6027 18.3332 10.0003C18.3332 5.39795 14.6022 1.66699 9.99984 1.66699C5.39746 1.66699 1.6665 5.39795 1.6665 10.0003C1.6665 14.6027 5.39746 18.3337 9.99984 18.3337ZM14.9612 10.6252H12.4211C12.3061 11.0721 12.0706 11.4706 11.7514 11.7841L13.0216 13.9842C14.0672 13.1899 14.7906 11.9934 14.9612 10.6252ZM11.9396 14.6101L10.6692 12.4097C10.4562 12.4688 10.2317 12.5003 9.99984 12.5003C9.76797 12.5003 9.54347 12.4688 9.33041 12.4097L8.06001 14.6101C8.65649 14.8614 9.31194 15.0003 9.99984 15.0003C10.6877 15.0003 11.3431 14.8614 11.9396 14.6101ZM6.978 13.9842L8.24822 11.7841C7.92901 11.4706 7.69356 11.0721 7.57857 10.6252H5.03851C5.20908 11.9934 5.93243 13.1899 6.978 13.9842ZM14.9611 9.37522H12.421C12.306 8.9284 12.0706 8.52993 11.7514 8.21647L13.0216 6.01639C14.0672 6.81066 14.7905 8.00711 14.9611 9.37522ZM11.9396 5.39051C11.3431 5.13923 10.6877 5.00033 9.99984 5.00033C9.31196 5.00033 8.65653 5.13923 8.06006 5.39053L9.33047 7.59094C9.54352 7.53189 9.76799 7.50033 9.99984 7.50033C10.2317 7.50033 10.4561 7.53188 10.6692 7.59093L11.9396 5.39051ZM8.24827 8.21651L6.97805 6.01642C5.9325 6.81069 5.20916 8.00713 5.03853 9.37522H7.57863C7.69365 8.92842 7.92908 8.52996 8.24827 8.21651Z",
        fill: "currentColor"
      }
    ]
  ],

  roleSuitcase: [
    [
      "path",
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M10.0432 1.04199H9.9565C9.20779 1.04197 8.58342 1.04195 8.08777 1.10859C7.56461 1.17893 7.09228 1.33365 6.71272 1.71321C6.33316 2.09277 6.17844 2.5651 6.1081 3.08826C6.04146 3.58391 6.04148 4.20825 6.0415 4.95698V5.02176C4.35719 5.07686 3.34577 5.27369 2.64281 5.97664C1.6665 6.95295 1.6665 8.5243 1.6665 11.667C1.6665 14.8097 1.6665 16.381 2.64281 17.3574C3.61913 18.3337 5.19047 18.3337 8.33317 18.3337H11.6665C14.8092 18.3337 16.3805 18.3337 17.3569 17.3574C18.3332 16.381 18.3332 14.8097 18.3332 11.667C18.3332 8.5243 18.3332 6.95295 17.3569 5.97664C16.6539 5.27369 15.6425 5.07687 13.9582 5.02176V4.957C13.9582 4.20828 13.9582 3.58391 13.8916 3.08826C13.8212 2.5651 13.6665 2.09277 13.287 1.71321C12.9074 1.33365 12.4351 1.17893 11.9119 1.10859C11.4163 1.04195 10.7919 1.04197 10.0432 1.04199ZM12.7082 5.0019V5.00033C12.7082 4.19699 12.7068 3.65735 12.6527 3.25482C12.601 2.87027 12.5117 2.70569 12.4031 2.59709C12.2945 2.4885 12.1299 2.39914 11.7453 2.34744C11.3428 2.29332 10.8032 2.292 9.99984 2.292C9.1965 2.292 8.65686 2.29332 8.25433 2.34744C7.86978 2.39914 7.7052 2.4885 7.5966 2.59709C7.48801 2.70569 7.39865 2.87027 7.34695 3.25482C7.29283 3.65735 7.29151 4.19699 7.29151 5.00033V5.0019C7.6182 5.00033 7.96489 5.00033 8.33317 5.00033H11.6665C12.0348 5.00033 12.3815 5.00033 12.7082 5.0019ZM14.1665 7.50033C14.1665 7.96056 13.7934 8.33366 13.3332 8.33366C12.8729 8.33366 12.4998 7.96056 12.4998 7.50033C12.4998 7.04009 12.8729 6.66699 13.3332 6.66699C13.7934 6.66699 14.1665 7.04009 14.1665 7.50033ZM6.6665 8.33366C7.12674 8.33366 7.49984 7.96056 7.49984 7.50033C7.49984 7.04009 7.12674 6.66699 6.6665 6.66699C6.20627 6.66699 5.83317 7.04009 5.83317 7.50033C5.83317 7.96056 6.20627 8.33366 6.6665 8.33366Z",
        fill: "currentColor"
      }
    ]
  ],

  roleHeartPulse: [
    [
      "path",
      {
        d: "M1.95478 9.37507C1.77032 8.82221 1.6665 8.26683 1.6665 7.71703C1.6665 2.79125 6.24997 0.552197 9.99984 4.58231C13.7497 0.552197 18.3332 2.79109 18.3332 7.717C18.3332 8.26681 18.2294 8.8222 18.0449 9.37507H15.5299L15.4366 9.37497C14.9818 9.37422 14.5779 9.37356 14.2104 9.53726C13.8428 9.70095 13.5731 10.0017 13.2693 10.3403L13.2069 10.4098L12.3492 11.3628C12.2853 11.4338 12.2331 11.4917 12.1871 11.5411C12.1434 11.4899 12.0939 11.4299 12.0333 11.3564L9.07389 7.76932C8.95761 7.62826 8.8332 7.47734 8.71148 7.36534C8.56975 7.2349 8.36022 7.08818 8.0673 7.07058C7.77438 7.05299 7.5488 7.17358 7.39247 7.28611C7.25822 7.38275 7.11664 7.51769 6.98431 7.64382L5.70961 8.85783C5.31646 9.23225 5.23443 9.29604 5.14862 9.33037C5.06281 9.36469 4.95942 9.37507 4.4165 9.37507H1.95478Z",
        fill: "currentColor"
      }
    ],
    [
      "path",
      {
        d: "M2.50351 10.6251C3.65433 12.76 5.77508 14.7618 7.46795 16.1423C8.57794 17.0474 9.13294 17.5 9.99984 17.5C10.8667 17.5 11.4217 17.0474 12.5317 16.1423C14.2246 14.7618 16.3454 12.76 17.4962 10.6251H15.5299C14.9264 10.6251 14.812 10.6377 14.7189 10.6791C14.6259 10.7206 14.5399 10.7972 14.136 11.246L13.257 12.2227C13.1254 12.369 12.9864 12.5236 12.8528 12.6356C12.6985 12.765 12.4688 12.9101 12.1578 12.9034C11.847 12.8967 11.6238 12.742 11.4752 12.6061C11.3465 12.4885 11.2144 12.3282 11.0893 12.1765L8.12889 8.58811C8.07262 8.5199 8.02683 8.46444 7.98642 8.41709C7.94064 8.45926 7.88854 8.50884 7.82451 8.56982L6.51106 9.82085C6.21442 10.1042 5.95121 10.3556 5.61286 10.491C5.27451 10.6263 4.91052 10.6258 4.50029 10.6252L2.50351 10.6251Z",
        fill: "currentColor"
      }
    ]
  ],

  roleAdhesivePlaster: [
    [
      "path",
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M2.67751 2.678C1.3295 4.026 1.3295 6.21155 2.67751 7.55955L12.4406 17.3227C13.7886 18.6707 15.9742 18.6707 17.3222 17.3227C18.6702 15.9747 18.6702 13.7891 17.3222 12.4411L7.55906 2.678C6.21106 1.32999 4.02551 1.32999 2.67751 2.678ZM7.78698 6.85936C7.53069 6.60306 7.11516 6.60306 6.85887 6.85936C6.60257 7.11565 6.60257 7.53118 6.85887 7.78747C7.11516 8.04376 7.53069 8.04376 7.78698 7.78747C8.04328 7.53118 8.04328 7.11565 7.78698 6.85936ZM10.1073 7.63279C9.85098 7.37649 9.43545 7.37649 9.17916 7.63279C8.92287 7.88908 8.92287 8.30461 9.17916 8.5609C9.43545 8.8172 9.85098 8.8172 10.1073 8.5609C10.3636 8.30461 10.3636 7.88908 10.1073 7.63279ZM13.201 10.7265C13.4573 10.9828 13.4573 11.3983 13.201 11.6546C12.9447 11.9109 12.5292 11.9109 12.2729 11.6546C12.0166 11.3983 12.0166 10.9828 12.2729 10.7265C12.5292 10.4702 12.9447 10.4702 13.201 10.7265ZM13.9744 13.9749C14.2307 13.7186 14.2307 13.3031 13.9744 13.0468C13.7181 12.7905 13.3026 12.7905 13.0463 13.0468C12.79 13.3031 12.79 13.7186 13.0463 13.9749C13.3026 14.2312 13.7181 14.2312 13.9744 13.9749ZM10.8807 10.8812C11.137 10.6249 11.137 10.2094 10.8807 9.95308C10.6244 9.69678 10.2089 9.69678 9.95259 9.95308C9.6963 10.2094 9.6963 10.6249 9.95259 10.8812C10.2089 11.1375 10.6244 11.1375 10.8807 10.8812ZM11.6541 12.2734C11.9104 12.5297 11.9104 12.9452 11.6541 13.2015C11.3978 13.4578 10.9823 13.4578 10.726 13.2015C10.4697 12.9452 10.4697 12.5297 10.726 12.2734C10.9823 12.0171 11.3978 12.0171 11.6541 12.2734ZM7.6323 9.17965C7.88859 8.92335 8.30412 8.92335 8.56042 9.17965C8.81671 9.43594 8.81671 9.85147 8.56042 10.1078C8.30412 10.3641 7.88859 10.3641 7.6323 10.1078C7.37601 9.85147 7.37601 9.43594 7.6323 9.17965Z",
        fill: "currentColor"
      }
    ],
    [
      "path",
      {
        d: "M4.2344 10.8842L2.67751 12.4411C1.3295 13.7891 1.3295 15.9747 2.67751 17.3227C4.02551 18.6707 6.21106 18.6707 7.55906 17.3227L9.11595 15.7658L4.2344 10.8842Z",
        fill: "currentColor"
      }
    ],
    [
      "path",
      {
        d: "M15.7653 9.11644L17.3222 7.55955C18.6702 6.21154 18.6702 4.026 17.3222 2.678C15.9742 1.32999 13.7886 1.32999 12.4406 2.678L10.8837 4.23489L15.7653 9.11644Z",
        fill: "currentColor"
      }
    ]
  ],

  roleHeadphones: [
    [
      "path",
      {
        d: "M0 8.4367C0 3.77724 3.73094 0 8.33329 0C12.9356 0 16.6666 3.77724 16.6666 8.4367L16.6666 12.8062C16.6668 13.487 16.667 13.9538 16.5473 14.3637C16.3133 15.1652 15.7538 15.8281 15.0083 16.1871C14.6271 16.3707 14.1716 16.4434 13.5074 16.5493L13.3991 16.5666C13.1628 16.6043 12.961 16.6366 12.7935 16.6533C12.6193 16.6706 12.4416 16.6759 12.2598 16.6397C11.6618 16.5204 11.1686 16.0938 10.959 15.5144C10.8953 15.3382 10.8728 15.1597 10.8625 14.9828C10.8526 14.8127 10.8527 14.6059 10.8527 14.3638L10.8526 10.8868C10.8522 10.5322 10.8518 10.2271 10.9329 9.96581C11.1185 9.36802 11.6032 8.91459 12.2064 8.77432C12.4701 8.713 12.7705 8.73738 13.1196 8.76572L13.1973 8.772L13.2888 8.77929C13.9419 8.83126 14.3887 8.86682 14.768 9.00885C15.0346 9.10865 15.2818 9.24608 15.5038 9.41468V8.4367C15.5038 4.4274 12.2935 1.17721 8.33329 1.17721C4.37313 1.17721 1.16278 4.4274 1.16278 8.4367V9.41468C1.3848 9.24608 1.63202 9.10865 1.89858 9.00885C2.27788 8.86682 2.72471 8.83126 3.37779 8.77929L3.46932 8.772L3.54701 8.76572C3.89612 8.73738 4.19651 8.713 4.4602 8.77432C5.06343 8.91459 5.54805 9.36802 5.73366 9.96581C5.81479 10.2271 5.81442 10.5322 5.81399 10.8868L5.81392 14.3638C5.81393 14.6058 5.81393 14.8127 5.80406 14.9828C5.79378 15.1597 5.77125 15.3382 5.70755 15.5144C5.49795 16.0938 5.00479 16.5204 4.40677 16.6397C4.22501 16.6759 4.04729 16.6706 3.87307 16.6533C3.70559 16.6366 3.50374 16.6043 3.26752 16.5666L3.15921 16.5493C2.49499 16.4434 2.03948 16.3707 1.65826 16.1871C0.912783 15.8281 0.353233 15.1652 0.119232 14.3637C0.0205592 14.0257 0.00336418 13.649 0.000503634 13.1456L0 12.9836V8.4367Z",
        fill: "currentColor"
      }
    ],
    [
      "path",
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M8.33329 3.125C8.67847 3.125 8.95829 3.40482 8.95829 3.75L8.95829 7.91667C8.95829 8.26184 8.67847 8.54167 8.33329 8.54167C7.98811 8.54167 7.70829 8.26184 7.70829 7.91667L7.70829 3.75C7.70829 3.40482 7.98811 3.125 8.33329 3.125Z",
        fill: "currentColor"
      }
    ],
    [
      "path",
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M10.8333 4.375C11.1785 4.375 11.4583 4.65482 11.4583 5V6.66667C11.4583 7.01184 11.1785 7.29167 10.8333 7.29167C10.4881 7.29167 10.2083 7.01184 10.2083 6.66667V5C10.2083 4.65482 10.4881 4.375 10.8333 4.375Z",
        fill: "currentColor"
      }
    ],
    [
      "path",
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M5.83329 4.375C6.17847 4.375 6.45829 4.65482 6.45829 5V6.66667C6.45829 7.01184 6.17847 7.29167 5.83329 7.29167C5.48811 7.29167 5.20829 7.01184 5.20829 6.66667V5C5.20829 4.65482 5.48811 4.375 5.83329 4.375Z",
        fill: "currentColor"
      }
    ]
  ],

  roleDumbbell: [
    [
      "path",
      {
        d: "M6.98368 17.1405L2.85939 13.0162C2.1059 12.2627 1.72915 11.886 1.67542 11.4259C1.66342 11.3232 1.66342 11.2194 1.67542 11.1167C1.72915 10.6567 2.1059 10.2799 2.85939 9.52643C3.61288 8.77293 3.98963 8.39619 4.44971 8.34245C4.55241 8.33046 4.65616 8.33046 4.75886 8.34245C5.21893 8.39619 5.59568 8.77293 6.34917 9.52643L6.9602 10.1375L10.1371 6.96057L9.52606 6.34954C8.77257 5.59605 8.39582 5.2193 8.34209 4.75922C8.33009 4.65652 8.33009 4.55277 8.34209 4.45007C8.39582 3.99 8.77257 3.61325 9.52606 2.85976C10.2796 2.10627 10.6563 1.72952 11.1164 1.67579C11.2191 1.66379 11.3228 1.66379 11.4255 1.67579C11.8856 1.72952 12.2623 2.10627 13.0158 2.85976L17.1401 6.98404C17.8936 7.73753 18.2704 8.11428 18.3241 8.57436C18.3361 8.67706 18.3361 8.7808 18.3241 8.8835C18.2704 9.34358 17.8936 9.72033 17.1401 10.4738C16.3866 11.2273 16.0099 11.6041 15.5498 11.6578C15.4471 11.6698 15.3434 11.6698 15.2407 11.6578C14.7806 11.6041 14.4038 11.2273 13.6503 10.4738L12.7238 9.54724L9.54688 12.7241L10.4735 13.6507C11.2269 14.4042 11.6037 14.7809 11.6574 15.241C11.6694 15.3437 11.6694 15.4475 11.6574 15.5502C11.6037 16.0102 11.2269 16.387 10.4735 17.1405C9.71996 17.894 9.34321 18.2707 8.88314 18.3245C8.78044 18.3365 8.67669 18.3365 8.57399 18.3245C8.11391 18.2707 7.73717 17.894 6.98368 17.1405Z",
        fill: "currentColor"
      }
    ],
    [
      "path",
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M14.5735 1.64009C14.8176 1.39601 15.2133 1.39601 15.4574 1.64009L18.044 4.22677C18.2881 4.47084 18.2881 4.86657 18.044 5.11065C17.8 5.35473 17.4042 5.35473 17.1602 5.11065L14.5735 2.52397C14.3294 2.2799 14.3294 1.88417 14.5735 1.64009ZM1.63911 14.5733C1.88319 14.3293 2.27892 14.3293 2.523 14.5733L5.10967 17.16C5.35375 17.4041 5.35375 17.7998 5.10967 18.0439C4.86559 18.288 4.46987 18.288 4.22579 18.0439L1.63911 15.4572C1.39504 15.2131 1.39504 14.8174 1.63911 14.5733Z",
        fill: "currentColor"
      }
    ]
  ],

  roleShop: [
    [
      "path",
      {
        d: "M13.773 1.66699H6.22667C5.22432 1.66699 4.72315 1.66699 4.3204 1.91591C3.91764 2.16482 3.69351 2.61309 3.24525 3.50961L2.07557 6.4664C1.80533 7.14953 1.56888 7.9547 2.02378 8.53156C2.32896 8.91856 2.80203 9.16699 3.33315 9.16699C4.25363 9.16699 4.99982 8.4208 4.99982 7.50033C4.99982 8.4208 5.74601 9.16699 6.66649 9.16699C7.58696 9.16699 8.33315 8.4208 8.33315 7.50033C8.33315 8.4208 9.07935 9.16699 9.99982 9.16699C10.9203 9.16699 11.6665 8.4208 11.6665 7.50033C11.6665 8.4208 12.4127 9.16699 13.3332 9.16699C14.2536 9.16699 14.9998 8.4208 14.9998 7.50033C14.9998 8.4208 15.746 9.16699 16.6665 9.16699C17.1976 9.16699 17.6707 8.91856 17.9759 8.53155C18.4308 7.9547 18.1944 7.14953 17.9241 6.4664L16.7545 3.50961C16.3062 2.61309 16.0821 2.16482 15.6793 1.91591C15.2766 1.66699 14.7754 1.66699 13.773 1.66699Z",
        fill: "currentColor"
      }
    ],
    [
      "path",
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M16.6665 17.708H18.3332C18.6783 17.708 18.9582 17.9878 18.9582 18.333C18.9582 18.6782 18.6783 18.958 18.3332 18.958H1.6665C1.32133 18.958 1.0415 18.6782 1.0415 18.333C1.0415 17.9878 1.32133 17.708 1.6665 17.708H3.33317L3.33317 10.4163C3.95286 10.4163 4.52741 10.2231 4.99984 9.89355C5.47227 10.2231 6.04682 10.4163 6.66651 10.4163C7.28619 10.4163 7.86074 10.2231 8.33317 9.89355C8.8056 10.2231 9.38015 10.4163 9.99984 10.4163C10.6195 10.4163 11.1941 10.2231 11.6665 9.89355C12.1389 10.2231 12.7135 10.4163 13.3332 10.4163C13.9529 10.4163 14.5274 10.2231 14.9998 9.89355C15.4723 10.2231 16.0468 10.4163 16.6665 10.4163L16.6665 17.708ZM7.9165 17.708H12.0832V15.4163C12.0832 14.6375 12.0832 14.2481 11.9157 13.958C11.806 13.768 11.6482 13.6102 11.4582 13.5005C11.1681 13.333 10.7787 13.333 9.99984 13.333C9.22099 13.333 8.83157 13.333 8.5415 13.5005C8.35148 13.6102 8.19368 13.768 8.08397 13.958C7.9165 14.2481 7.9165 14.6375 7.9165 15.4163V17.708Z",
        fill: "currentColor"
      }
    ]
  ],

  roleAcademicHat: [
    [
      "path",
      {
        d: "M11.8475 2.91637C10.6633 2.36121 9.33627 2.36121 8.1521 2.91637L2.57617 5.53049C1.67951 5.95087 1.44573 7.13627 1.87484 7.95555L1.87484 12.0833C1.87484 12.4285 2.15466 12.7083 2.49984 12.7083C2.84502 12.7083 3.12484 12.4285 3.12484 12.0833V8.89336L8.15217 11.2503C9.33635 11.8055 10.6634 11.8055 11.8476 11.2503L17.4235 8.63617C18.6364 8.06754 18.6364 6.09916 17.4235 5.53053L11.8475 2.91637Z",
        fill: "currentColor"
      }
    ],
    [
      "path",
      {
        d: "M4.1665 10.7623V13.8545C4.1665 14.6945 4.58609 15.481 5.32095 15.888C6.54459 16.5656 8.50317 17.5 9.99984 17.5C11.4965 17.5 13.4551 16.5656 14.6787 15.888C15.4136 15.481 15.8332 14.6945 15.8332 13.8545V10.7623L12.3782 12.3821C10.8578 13.0949 9.14192 13.0949 7.62157 12.3821L4.1665 10.7623Z",
        fill: "currentColor"
      }
    ]
  ],

  roleChefHat: [
    [
      "path",
      {
        d: "M5.83317 4.16699C3.53198 4.16699 1.6665 6.03247 1.6665 8.33366C1.6665 10.0423 2.69492 11.5107 4.1665 12.1536V14.3753H15.8332L15.8332 12.1536C17.3048 11.5107 18.3332 10.0423 18.3332 8.33366C18.3332 6.03247 16.4677 4.16699 14.1665 4.16699C13.9577 4.16699 13.7526 4.18235 13.552 4.21198C13.0502 2.73204 11.6494 1.66699 9.99984 1.66699C8.3503 1.66699 6.94952 2.73204 6.44764 4.21198C6.24711 4.18235 6.04194 4.16699 5.83317 4.16699Z",
        fill: "currentColor"
      }
    ],
    [
      "path",
      {
        d: "M15.8318 15.6253H4.16791C4.17641 16.7894 4.23603 17.4269 4.65466 17.8455C5.14281 18.3337 5.92849 18.3337 7.49984 18.3337H12.4998C14.0712 18.3337 14.8569 18.3337 15.345 17.8455C15.7636 17.4269 15.8233 16.7894 15.8318 15.6253Z",
        fill: "currentColor"
      }
    ]
  ],

  roleRulerAngular: [
    [
      "path",
      {
        d: "M6.87484 1.66699H4.99984C3.42849 1.66699 2.64281 1.66699 2.15466 2.15515C1.6665 2.6433 1.6665 3.42898 1.6665 5.00033V6.87533H4.1665C4.51168 6.87533 4.7915 7.15515 4.7915 7.50033C4.7915 7.8455 4.51168 8.12533 4.1665 8.12533H1.6665V9.37533H3.33317C3.67835 9.37533 3.95817 9.65515 3.95817 10.0003C3.95817 10.3455 3.67835 10.6253 3.33317 10.6253H1.6665V11.8753L4.1665 11.8753C4.51168 11.8753 4.7915 12.1551 4.7915 12.5003C4.7915 12.8455 4.51168 13.1253 4.1665 13.1253L1.6665 13.1253V14.3753H3.33317C3.67835 14.3753 3.95817 14.6551 3.95817 15.0003C3.95817 15.3455 3.67835 15.6253 3.33317 15.6253H1.66657C1.66756 16.6584 1.68369 17.1983 1.94739 17.5929C2.06899 17.7749 2.22524 17.9312 2.40722 18.0528C2.82759 18.3337 3.41279 18.3337 4.58317 18.3337C5.75356 18.3337 6.33875 18.3337 6.75912 18.0528C6.9411 17.9312 7.09736 17.7749 7.21895 17.5929C7.49984 17.1726 7.49984 16.5874 7.49984 15.417V9.16699C7.49984 8.38132 7.49984 7.98848 7.74392 7.7444C7.98799 7.50033 8.38083 7.50033 9.1665 7.50033H15.4165C16.5869 7.50033 17.1721 7.50033 17.5925 7.21944C17.7744 7.09784 17.9307 6.94159 18.0523 6.75961C18.3332 6.33924 18.3332 5.75404 18.3332 4.58366C18.3332 3.41327 18.3332 2.82808 18.0523 2.40771C17.9307 2.22572 17.7744 2.06947 17.5925 1.94788C17.1978 1.68418 16.6579 1.66804 15.6248 1.66706V3.33366C15.6248 3.67884 15.345 3.95866 14.9998 3.95866C14.6547 3.95866 14.3748 3.67884 14.3748 3.33366V1.66699H13.1248V4.16699C13.1248 4.51217 12.845 4.79199 12.4998 4.79199C12.1547 4.79199 11.8748 4.51217 11.8748 4.16699V1.66699H10.6248V3.33366C10.6248 3.67884 10.345 3.95866 9.99984 3.95866C9.65466 3.95866 9.37484 3.67884 9.37484 3.33366V1.66699H8.12484L8.12484 4.16699C8.12484 4.51217 7.84501 4.79199 7.49984 4.79199C7.15466 4.79199 6.87484 4.51217 6.87484 4.16699L6.87484 1.66699Z",
        fill: "currentColor"
      }
    ]
  ],

  rolePalette: [
    [
      "path",
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M9.03883 18.2788C4.88911 17.8024 1.6665 14.2777 1.6665 10.0003C1.6665 5.39795 5.39746 1.66699 9.99984 1.66699C14.6022 1.66699 18.3332 5.39795 18.3332 10.0003C18.3332 14.2974 15.5976 13.9441 13.2611 13.6422C11.9135 13.4682 10.6987 13.3112 10.2181 14.0736C9.88938 14.595 10.2447 15.2452 10.6805 15.681C11.2251 16.2256 11.2251 17.1084 10.6805 17.653C10.2447 18.0888 9.65116 18.3492 9.03883 18.2788ZM9.23734 5.83346C9.23734 6.52381 8.6777 7.08346 7.98734 7.08346C7.29698 7.08346 6.73734 6.52381 6.73734 5.83346C6.73734 5.1431 7.29698 4.58346 7.98734 4.58346C8.6777 4.58346 9.23734 5.1431 9.23734 5.83346ZM5.4165 10.8336C6.10686 10.8336 6.6665 10.274 6.6665 9.58365C6.6665 8.89329 6.10686 8.33365 5.4165 8.33365C4.72615 8.33365 4.1665 8.89329 4.1665 9.58365C4.1665 10.274 4.72615 10.8336 5.4165 10.8336ZM14.5832 10.8336C15.2735 10.8336 15.8332 10.274 15.8332 9.58365C15.8332 8.89329 15.2735 8.33365 14.5832 8.33365C13.8928 8.33365 13.3332 8.89329 13.3332 9.58365C13.3332 10.274 13.8928 10.8336 14.5832 10.8336ZM12.0832 7.08365C12.7735 7.08365 13.3332 6.524 13.3332 5.83365C13.3332 5.14329 12.7735 4.58365 12.0832 4.58365C11.3928 4.58365 10.8332 5.14329 10.8332 5.83365C10.8332 6.524 11.3928 7.08365 12.0832 7.08365Z",
        fill: "currentColor"
      }
    ]
  ],

  rolePaintRoller: [
    [
      "path",
      {
        d: "M5 3.75033C5 2.97148 5 2.58206 5.16747 2.29199C5.27718 2.10197 5.43498 1.94417 5.625 1.83446C5.91506 1.66699 6.30449 1.66699 7.08333 1.66699H12.9167C13.6955 1.66699 14.0849 1.66699 14.375 1.83446C14.565 1.94417 14.7228 2.10197 14.8325 2.29199C15 2.58206 15 2.97148 15 3.75033C15 4.52917 15 4.9186 14.8325 5.20866C14.7228 5.39868 14.565 5.55648 14.375 5.66619C14.0849 5.83366 13.6955 5.83366 12.9167 5.83366H7.08333C6.30449 5.83366 5.91506 5.83366 5.625 5.66619C5.43498 5.55648 5.27718 5.39868 5.16747 5.20866C5 4.9186 5 4.52917 5 3.75033Z",
        fill: "currentColor"
      }
    ],
    [
      "path",
      {
        d: "M4.16861 3.28223C4.03971 3.39672 3.9585 3.56371 3.9585 3.74967C3.9585 3.93563 4.03971 4.10263 4.16861 4.21712C4.16681 4.07981 4.16682 3.9347 4.16683 3.7832V3.71615C4.16682 3.56465 4.16681 3.41953 4.16861 3.28223Z",
        fill: "currentColor"
      }
    ],
    [
      "path",
      {
        d: "M8.3335 13.3337V16.667C8.3335 17.4527 8.3335 17.8455 8.57757 18.0896C8.82165 18.3337 9.21449 18.3337 10.0002 18.3337C10.7858 18.3337 11.1787 18.3337 11.4228 18.0896C11.6668 17.8455 11.6668 17.4527 11.6668 16.667V13.3337C11.6668 12.548 11.6668 12.1551 11.4228 11.9111C11.1787 11.667 10.7858 11.667 10.0002 11.667C9.21449 11.667 8.82165 11.667 8.57757 11.9111C8.3335 12.1551 8.3335 12.548 8.3335 13.3337Z",
        fill: "currentColor"
      }
    ],
    [
      "path",
      {
        d: "M15.8284 4.375H15.8708C16.2497 4.375 16.504 4.37531 16.7011 4.38816C16.8929 4.40067 16.9866 4.42313 17.0483 4.44741C17.3172 4.55329 17.5301 4.76614 17.636 5.03507C17.6603 5.09674 17.6827 5.19049 17.6952 5.38232C17.7081 5.57942 17.7084 5.8337 17.7084 6.21259C17.7084 6.91036 17.6996 7.10154 17.6489 7.24493C17.562 7.49098 17.3859 7.69546 17.1555 7.8179C17.0212 7.88925 16.8334 7.92633 16.1434 8.02984L12.7073 8.54526C12.0634 8.64182 11.5228 8.72288 11.0958 8.84297C10.6432 8.97022 10.2428 9.16028 9.93023 9.52321C9.61095 9.89395 9.47914 10.3379 9.42236 10.8385C9.59251 10.8333 9.77222 10.8333 9.95457 10.8333H10.0453C10.2661 10.8333 10.483 10.8333 10.6838 10.8425C10.7255 10.5752 10.7899 10.4405 10.8774 10.3389C10.9686 10.233 11.1086 10.1378 11.4341 10.0463C11.7765 9.95002 12.2385 9.87956 12.9316 9.77559L16.4281 9.25118C16.9704 9.1703 17.3928 9.10731 17.742 8.92175C18.249 8.65238 18.6364 8.20254 18.8276 7.66122C18.9593 7.28832 18.9589 6.86128 18.9584 6.31299L18.9584 6.19248C18.9584 5.83885 18.9584 5.54361 18.9426 5.301C18.9261 5.04853 18.8907 4.80976 18.7991 4.57715C18.5661 3.98551 18.0979 3.51724 17.5062 3.28431C17.2736 3.19273 17.0349 3.15727 16.7824 3.14081C16.5398 3.12499 16.2445 3.12499 15.8909 3.125H15.8284C15.8333 3.30723 15.8333 3.50567 15.8332 3.71647V3.78354C15.8333 3.99433 15.8333 4.19277 15.8284 4.375Z",
        fill: "currentColor"
      }
    ]
  ],

  roleCalculator: [
    [
      "path",
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M10 18.3337C6.46447 18.3337 4.6967 18.3337 3.59835 17.1133C2.5 15.8929 2.5 13.9287 2.5 10.0003C2.5 6.07195 2.5 4.10777 3.59835 2.88738C4.6967 1.66699 6.46447 1.66699 10 1.66699C13.5355 1.66699 15.3033 1.66699 16.4016 2.88738C17.5 4.10777 17.5 6.07195 17.5 10.0003C17.5 13.9287 17.5 15.8929 16.4016 17.1133C15.3033 18.3337 13.5355 18.3337 10 18.3337ZM12.5 5.00033H7.5C7.11251 5.00033 6.91877 5.00033 6.75981 5.04292C6.32844 5.1585 5.99151 5.49544 5.87593 5.9268C5.83333 6.08576 5.83333 6.2795 5.83333 6.66699C5.83333 7.05448 5.83333 7.24822 5.87593 7.40718C5.99151 7.83855 6.32844 8.17548 6.75981 8.29107C6.91877 8.33366 7.11251 8.33366 7.5 8.33366H12.5C12.8875 8.33366 13.0812 8.33366 13.2402 8.29107C13.6716 8.17548 14.0085 7.83855 14.1241 7.40718C14.1667 7.24822 14.1667 7.05448 14.1667 6.66699C14.1667 6.2795 14.1667 6.08576 14.1241 5.9268C14.0085 5.49544 13.6716 5.1585 13.2402 5.04292C13.0812 5.00033 12.8875 5.00033 12.5 5.00033ZM7.5 10.8337C7.5 11.2939 7.1269 11.667 6.66667 11.667C6.20643 11.667 5.83333 11.2939 5.83333 10.8337C5.83333 10.3734 6.20643 10.0003 6.66667 10.0003C7.1269 10.0003 7.5 10.3734 7.5 10.8337ZM10 11.667C10.4602 11.667 10.8333 11.2939 10.8333 10.8337C10.8333 10.3734 10.4602 10.0003 10 10.0003C9.53976 10.0003 9.16667 10.3734 9.16667 10.8337C9.16667 11.2939 9.53976 11.667 10 11.667ZM14.1667 10.8337C14.1667 11.2939 13.7936 11.667 13.3333 11.667C12.8731 11.667 12.5 11.2939 12.5 10.8337C12.5 10.3734 12.8731 10.0003 13.3333 10.0003C13.7936 10.0003 14.1667 10.3734 14.1667 10.8337ZM13.3333 15.0003C13.7936 15.0003 14.1667 14.6272 14.1667 14.167C14.1667 13.7068 13.7936 13.3337 13.3333 13.3337C12.8731 13.3337 12.5 13.7068 12.5 14.167C12.5 14.6272 12.8731 15.0003 13.3333 15.0003ZM10.8333 14.167C10.8333 14.6272 10.4602 15.0003 10 15.0003C9.53976 15.0003 9.16667 14.6272 9.16667 14.167C9.16667 13.7068 9.53976 13.3337 10 13.3337C10.4602 13.3337 10.8333 13.7068 10.8333 14.167ZM6.66667 15.0003C7.1269 15.0003 7.5 14.6272 7.5 14.167C7.5 13.7068 7.1269 13.3337 6.66667 13.3337C6.20643 13.3337 5.83333 13.7068 5.83333 14.167C5.83333 14.6272 6.20643 15.0003 6.66667 15.0003Z",
        fill: "currentColor"
      }
    ]
  ],

  roleStatistics: [
    [
      "path",
      {
        d: "M14.4107 1.91107C14.1667 2.15515 14.1667 2.54798 14.1667 3.33366V14.167C14.1667 14.9527 14.1667 15.3455 14.4107 15.5896C14.6548 15.8337 15.0477 15.8337 15.8333 15.8337C16.619 15.8337 17.0118 15.8337 17.2559 15.5896C17.5 15.3455 17.5 14.9527 17.5 14.167V3.33366C17.5 2.54798 17.5 2.15515 17.2559 1.91107C17.0118 1.66699 16.619 1.66699 15.8333 1.66699C15.0477 1.66699 14.6548 1.66699 14.4107 1.91107Z",
        fill: "currentColor"
      }
    ],
    [
      "path",
      {
        d: "M8.33333 5.83366C8.33333 5.04798 8.33333 4.65515 8.57741 4.41107C8.82149 4.16699 9.21433 4.16699 10 4.16699C10.7857 4.16699 11.1785 4.16699 11.4226 4.41107C11.6667 4.65515 11.6667 5.04798 11.6667 5.83366V14.167C11.6667 14.9527 11.6667 15.3455 11.4226 15.5896C11.1785 15.8337 10.7857 15.8337 10 15.8337C9.21433 15.8337 8.82149 15.8337 8.57741 15.5896C8.33333 15.3455 8.33333 14.9527 8.33333 14.167V5.83366Z",
        fill: "currentColor"
      }
    ],
    [
      "path",
      {
        d: "M2.74408 7.7444C2.5 7.98848 2.5 8.38132 2.5 9.16699V14.167C2.5 14.9527 2.5 15.3455 2.74408 15.5896C2.98816 15.8337 3.38099 15.8337 4.16667 15.8337C4.95234 15.8337 5.34518 15.8337 5.58926 15.5896C5.83333 15.3455 5.83333 14.9527 5.83333 14.167V9.16699C5.83333 8.38132 5.83333 7.98848 5.58926 7.7444C5.34518 7.50033 4.95234 7.50033 4.16667 7.50033C3.38099 7.50033 2.98816 7.50033 2.74408 7.7444Z",
        fill: "currentColor"
      }
    ],
    [
      "path",
      {
        d: "M2.5 17.7087C2.15482 17.7087 1.875 17.9885 1.875 18.3337C1.875 18.6788 2.15482 18.9587 2.5 18.9587H17.5C17.8452 18.9587 18.125 18.6788 18.125 18.3337C18.125 17.9885 17.8452 17.7087 17.5 17.7087H2.5Z",
        fill: "currentColor"
      }
    ]
  ],

  roleCodeSquare: [
    [
      "path",
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M2.88689 2.88738C1.6665 4.10777 1.6665 6.07195 1.6665 10.0003C1.6665 13.9287 1.6665 15.8929 2.88689 17.1133C4.10728 18.3337 6.07147 18.3337 9.99984 18.3337C13.9282 18.3337 15.8924 18.3337 17.1128 17.1133C18.3332 15.8929 18.3332 13.9287 18.3332 10.0003C18.3332 6.07195 18.3332 4.10777 17.1128 2.88738C15.8924 1.66699 13.9282 1.66699 9.99984 1.66699C6.07147 1.66699 4.10728 1.66699 2.88689 2.88738ZM11.2399 5.37192C11.5733 5.46125 11.7712 5.80396 11.6818 6.13738L9.525 14.1868C9.43566 14.5202 9.09295 14.718 8.75954 14.6287C8.42612 14.5394 8.22826 14.1967 8.3176 13.8632L10.4744 5.81386C10.5638 5.48044 10.9065 5.28258 11.2399 5.37192ZM12.4746 7.05839C12.7186 6.81431 13.1144 6.81431 13.3584 7.05839L13.5321 7.232C14.0615 7.76141 14.503 8.20289 14.8064 8.60049C15.1266 9.02015 15.3511 9.46355 15.3511 10.0003C15.3511 10.5371 15.1266 10.9805 14.8064 11.4002C14.503 11.7978 14.0615 12.2392 13.5321 12.7686L13.3584 12.9423C13.1144 13.1863 12.7186 13.1863 12.4746 12.9423C12.2305 12.6982 12.2305 12.3025 12.4746 12.0584L12.6175 11.9154C13.1856 11.3474 13.5662 10.9648 13.8126 10.6419C14.048 10.3335 14.1011 10.1539 14.1011 10.0003C14.1011 9.84675 14.048 9.66719 13.8126 9.35871C13.5662 9.03581 13.1856 8.6533 12.6175 8.08525L12.4746 7.94227C12.2305 7.69819 12.2305 7.30246 12.4746 7.05839ZM6.64138 7.05839C6.88546 6.81431 7.28119 6.81431 7.52527 7.05839C7.76935 7.30246 7.76935 7.69819 7.52527 7.94227L7.38229 8.08525C6.81424 8.6533 6.4336 9.03581 6.18724 9.35871C5.95188 9.66719 5.89868 9.84675 5.89868 10.0003C5.89868 10.1539 5.95188 10.3335 6.18724 10.6419C6.4336 10.9648 6.81424 11.3474 7.38229 11.9154L7.52527 12.0584C7.76935 12.3025 7.76935 12.6982 7.52527 12.9423C7.28119 13.1863 6.88546 13.1863 6.64138 12.9423L6.46776 12.7687C5.93831 12.2392 5.49682 11.7978 5.19346 11.4002C4.87326 10.9805 4.64868 10.5371 4.64868 10.0003C4.64868 9.46355 4.87326 9.02015 5.19346 8.60049C5.49682 8.20289 5.93832 7.76142 6.46777 7.232L6.64138 7.05839Z",
        fill: "currentColor"
      }
    ]
  ],

  roleSidebarCode: [
    [
      "path",
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M1.6665 9.16667C1.6665 6.02397 1.6665 4.45263 2.64281 3.47632C3.61913 2.5 5.19047 2.5 8.33317 2.5H11.6665H11.8748L11.8748 17.5H11.6665H8.33317C5.19047 17.5 3.61913 17.5 2.64281 16.5237C1.6665 15.5474 1.6665 13.976 1.6665 10.8333V9.16667ZM13.1248 17.4953L13.1248 2.50466C15.3214 2.52768 16.5449 2.66437 17.3569 3.47632C18.3332 4.45263 18.3332 6.02397 18.3332 9.16667V10.8333C18.3332 13.976 18.3332 15.5474 17.3569 16.5237C16.5449 17.3356 15.3214 17.4723 13.1248 17.4953ZM8.3079 12.8914C8.55197 12.6473 8.9477 12.6473 9.19178 12.8914L10.0251 13.7247C10.2692 13.9688 10.2692 14.3645 10.0251 14.6086L9.19178 15.4419C8.9477 15.686 8.55197 15.686 8.3079 15.4419C8.06382 15.1979 8.06382 14.8021 8.3079 14.5581L8.69929 14.1667L8.3079 13.7753C8.06382 13.5312 8.06382 13.1355 8.3079 12.8914ZM8.08504 11.8861C8.20624 11.5629 8.04249 11.2027 7.71929 11.0815C7.39609 10.9603 7.03583 11.124 6.91463 11.4472L5.66463 14.7806C5.54343 15.1038 5.70718 15.464 6.03038 15.5852C6.35358 15.7064 6.71384 15.5427 6.83504 15.2195L8.08504 11.8861ZM5.44178 11.2247C5.68586 11.4688 5.68586 11.8645 5.44178 12.1086L5.05039 12.5L5.44178 12.8914C5.68586 13.1355 5.68586 13.5312 5.44178 13.7753C5.1977 14.0194 4.80197 14.0194 4.55789 13.7753L3.72456 12.9419C3.48048 12.6979 3.48048 12.3021 3.72456 12.0581L4.5579 11.2247C4.80197 10.9807 5.1977 10.9807 5.44178 11.2247Z",
        fill: "currentColor"
      }
    ]
  ],

  run: [
    [
      "path",
      {
        d: "M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  ],

  chatGpt: [
    [
      "path",
      {
        d: "M14.9452 6.54825C15.0822 6.1422 15.152 5.71707 15.1521 5.28913C15.1521 4.58102 14.9609 3.88569 14.5983 3.27463C13.8696 2.02316 12.5179 1.25052 11.055 1.25052C10.7668 1.25052 10.4795 1.28055 10.1976 1.34012C9.81861 0.918748 9.35335 0.581446 8.83255 0.35045C8.31175 0.119454 7.74723 1.23153e-05 7.17623 0H7.15058L7.14096 5.58284e-05C5.36915 5.58284e-05 3.79786 1.12813 3.25319 2.79117C2.68939 2.90511 2.15676 3.13657 1.69095 3.47006C1.22515 3.80355 0.836919 4.23138 0.552257 4.7249C0.190734 5.33964 0.000221225 6.03771 0 6.74845C0.000138161 7.74731 0.375921 8.71059 1.05458 9.45175C0.917588 9.85778 0.847722 10.2829 0.847726 10.7109C0.847726 11.419 1.03889 12.1143 1.4015 12.7254C1.83272 13.4662 2.49124 14.0527 3.28211 14.4004C4.07298 14.748 4.95532 14.8389 5.8019 14.6598C6.18099 15.0812 6.64629 15.4185 7.16712 15.6495C7.68796 15.8805 8.25251 16 8.82355 16H8.84919L8.85961 15.9999C10.6324 15.9999 12.2032 14.8718 12.7478 13.2073C13.3116 13.0933 13.8443 12.8618 14.3101 12.5283C14.7759 12.1948 15.1641 11.767 15.4488 11.2735C15.8099 10.6593 16.0001 9.9618 16 9.25172C15.9999 8.25287 15.6241 7.28961 14.9454 6.54847L14.9452 6.54825ZM8.85021 14.954H8.84602C8.13666 14.9538 7.44982 14.7082 6.90494 14.26C6.9373 14.2429 6.96927 14.225 7.00084 14.2064L10.2296 12.3663C10.3102 12.321 10.3771 12.2555 10.4238 12.1764C10.4704 12.0974 10.4949 12.0075 10.495 11.916V7.42166L11.8597 8.19917C11.8668 8.20269 11.873 8.2079 11.8777 8.21434C11.8823 8.22078 11.8852 8.22825 11.8862 8.23609V11.9555C11.8844 13.6092 10.5263 14.9506 8.85021 14.954ZM2.32112 12.2025C2.05442 11.7475 1.91391 11.2312 1.91374 10.7056C1.91374 10.5342 1.92891 10.3623 1.95846 10.1934C1.98246 10.2076 2.02436 10.2328 2.05442 10.2499L5.28315 12.09C5.36365 12.1364 5.45519 12.1608 5.5484 12.1608C5.64161 12.1608 5.73314 12.1363 5.81362 12.0899L9.75556 9.84411V11.3992L9.75562 11.4018C9.75562 11.4093 9.75386 11.4167 9.75047 11.4234C9.74708 11.4301 9.74215 11.4359 9.73608 11.4404L6.47214 13.2999C6.0103 13.5621 5.48681 13.7002 4.95395 13.7004C4.42053 13.7003 3.8965 13.5619 3.4344 13.299C2.9723 13.036 2.58838 12.6579 2.32112 12.2024V12.2025ZM1.4717 5.24774C1.82632 4.63999 2.38626 4.17465 3.05352 3.93315C3.05352 3.96058 3.05194 4.00918 3.05194 4.04291V7.7233L3.05188 7.72632C3.05189 7.8177 3.07642 7.90745 3.12296 7.98646C3.16951 8.06547 3.23641 8.13091 3.31688 8.17615L7.25883 10.4216L5.89418 11.1991C5.88744 11.2035 5.87972 11.2062 5.87169 11.2069C5.86366 11.2076 5.85557 11.2064 5.84815 11.2033L2.58386 9.34227C2.1224 9.0785 1.73931 8.6997 1.47298 8.24383C1.20664 7.78795 1.06642 7.27101 1.06636 6.74482C1.06656 6.21945 1.20638 5.70331 1.47187 5.24791L1.4717 5.24774ZM12.6841 7.82223L8.74219 5.57647L10.1069 4.79925C10.1136 4.79486 10.1214 4.79219 10.1294 4.79147C10.1374 4.79075 10.1455 4.792 10.1529 4.79511L13.4172 6.65455C13.879 6.9179 14.2625 7.2965 14.5291 7.75233C14.7958 8.20816 14.9362 8.72518 14.9364 9.2515C14.9364 10.5077 14.1419 11.6318 12.9474 12.0656V8.27519C12.9476 8.27379 12.9476 8.27234 12.9476 8.27095C12.9475 8.1799 12.9232 8.09047 12.8769 8.01169C12.8307 7.9329 12.7642 7.86755 12.6841 7.82223ZM14.0424 5.8051C14.0107 5.78592 13.9787 5.76711 13.9465 5.74868L10.7178 3.90846C10.6373 3.86218 10.5458 3.83778 10.4526 3.83774C10.3595 3.83778 10.268 3.86218 10.1875 3.90846L6.24546 6.15428V4.59922L6.2454 4.59653C6.2454 4.58134 6.2527 4.56704 6.26499 4.55794L9.52894 2.70006C9.99062 2.43744 10.5142 2.29919 11.0471 2.29916C12.7253 2.29916 14.0863 3.64201 14.0863 5.2979C14.0862 5.46783 14.0715 5.63744 14.0424 5.80493V5.8051ZM5.50349 8.57672L4.1385 7.79922C4.13134 7.79569 4.12517 7.79048 4.12054 7.78404C4.1159 7.7776 4.11296 7.77013 4.11195 7.76229V4.0428C4.11269 2.38781 5.47366 1.04607 7.15115 1.04607C7.86162 1.04622 8.54961 1.29179 9.09574 1.74018C9.07117 1.75342 9.02831 1.77677 8.99984 1.7938L5.7711 3.63397C5.69054 3.67919 5.62355 3.74466 5.57694 3.82371C5.53034 3.90276 5.50578 3.99257 5.50576 4.08403V4.08699L5.50349 8.57672ZM6.24484 6.99965L8.00051 5.9991L9.75618 6.99898V8.9994L8.00051 9.99934L6.24484 8.9994V6.99965Z",
        fill: "currentColor"
      }
    ]
  ],

  googleGemini: [
    [
      "path",
      {
        d: "M11.04 19.32Q12 21.51 12 24q0-2.49.93-4.68.96-2.19 2.58-3.81t3.81-2.55Q21.51 12 24 12q-2.49 0-4.68-.93a12.3 12.3 0 0 1-3.81-2.58 12.3 12.3 0 0 1-2.58-3.81Q12 2.49 12 0q0 2.49-.96 4.68-.93 2.19-2.55 3.81a12.3 12.3 0 0 1-3.81 2.58Q2.49 12 0 12q2.49 0 4.68.96 2.19.93 3.81 2.55t2.55 3.81",
        fill: "currentColor"
      }
    ]
  ],

  linkHorizontal: [
    [
      "path",
      {
        d: "M4.5 1C2.567 1 1 2.567 1 4.5C1 6.433 2.567 8 4.5 8H5.16667C5.44281 8 5.66667 8.22386 5.66667 8.5C5.66667 8.77614 5.44281 9 5.16667 9H4.5C2.01472 9 0 6.98528 0 4.5C0 2.01472 2.01472 0 4.5 0H5.16667C5.44281 0 5.66667 0.223858 5.66667 0.5C5.66667 0.776142 5.44281 1 5.16667 1H4.5Z",
        fill: "currentColor"
      }
    ],
    [
      "path",
      {
        d: "M4.6666 4.49996C4.6666 4.22382 4.89046 3.99996 5.1666 3.99996H9.1666C9.44275 3.99996 9.6666 4.22382 9.6666 4.49996C9.6666 4.77611 9.44275 4.99996 9.1666 4.99996H5.1666C4.89046 4.99996 4.6666 4.77611 4.6666 4.49996Z",
        fill: "currentColor"
      }
    ],
    [
      "path",
      {
        d: "M9.16667 0C8.89052 0 8.66667 0.223858 8.66667 0.5C8.66667 0.776142 8.89052 1 9.16667 1H9.83333C11.7663 1 13.3333 2.567 13.3333 4.5C13.3333 6.433 11.7663 8 9.83333 8H9.16667C8.89052 8 8.66667 8.22386 8.66667 8.5C8.66667 8.77614 8.89052 9 9.16667 9H9.83333C12.3186 9 14.3333 6.98528 14.3333 4.5C14.3333 2.01472 12.3186 0 9.83333 0H9.16667Z",
        fill: "currentColor"
      }
    ]
  ],

  fileImage: [
    [
      "path",
      {
        opacity: "0.3",
        d: "M23.7852 8.38534C22.854 8.38489 21.9611 8.01479 21.3027 7.35636C20.6442 6.69792 20.2741 5.80502 20.2737 4.87385V0H4.58268C3.98073 -4.15623e-08 3.38469 0.118583 2.82858 0.348989C2.27248 0.579395 1.76718 0.917104 1.34162 1.34282C0.916057 1.76854 0.578565 2.27393 0.348366 2.83012C0.118166 3.38631 -0.000223372 3.98241 3.1639e-07 4.58436V32.208C-0.000223372 32.8099 0.118166 33.406 0.348366 33.9622C0.578565 34.5184 0.916057 35.0238 1.34162 35.4495C1.76718 35.8752 2.27248 36.2129 2.82858 36.4433C3.38469 36.6737 3.98073 36.7923 4.58268 36.7923H23.4173C24.0193 36.7923 24.6153 36.6737 25.1714 36.4433C25.7275 36.2129 26.2328 35.8752 26.6583 35.4495C27.0839 35.0238 27.4214 34.5184 27.6516 33.9622C27.8818 33.406 28.0002 32.8099 28 32.208V8.38705L23.7852 8.38534Z",
        fill: "#00C650"
      }
    ],
    [
      "path",
      {
        d: "M27.9999 8.38534H23.7851C22.854 8.38489 21.9611 8.01479 21.3026 7.35636C20.6442 6.69792 20.2741 5.80502 20.2736 4.87385V0L27.9999 8.38534Z",
        fill: "#00C650"
      }
    ],
    [
      "path",
      {
        d: "M17.7622 24.9325H10.2402C9.50387 24.9316 8.79791 24.6386 8.27722 24.1179C7.75653 23.5973 7.46361 22.8913 7.46271 22.1549V14.633C7.46361 13.8966 7.75653 13.1907 8.27722 12.67C8.79791 12.1493 9.50387 11.8564 10.2402 11.8555H17.7622C18.4984 11.8564 19.2041 12.1493 19.7246 12.6701C20.245 13.1908 20.5375 13.8968 20.538 14.633V22.1549C20.5375 22.8911 20.245 23.5971 19.7246 24.1178C19.2041 24.6386 18.4984 24.9316 17.7622 24.9325ZM10.2402 13.0833C9.82937 13.0837 9.43544 13.2472 9.14492 13.5377C8.85439 13.8282 8.69098 14.2221 8.69053 14.633V22.1549C8.69098 22.5658 8.85439 22.9597 9.14492 23.2502C9.43544 23.5408 9.82937 23.7042 10.2402 23.7046H17.7622C18.1729 23.7042 18.5666 23.5407 18.8569 23.2501C19.1471 22.9596 19.3102 22.5656 19.3102 22.1549V14.633C19.3102 14.2223 19.1471 13.8284 18.8569 13.5378C18.5666 13.2472 18.1729 13.0837 17.7622 13.0833H10.2402Z",
        fill: "#00C650"
      }
    ],
    [
      "path",
      {
        d: "M19.9246 20.7253V22.1558C19.9241 22.7292 19.6961 23.2791 19.2906 23.6846C18.8851 24.0901 18.3353 24.3181 17.7618 24.3185H10.2399C9.66629 24.3185 9.1162 24.0907 8.7106 23.6851C8.30501 23.2795 8.07715 22.7294 8.07715 22.1558V19.7546C9.28114 19.4958 11.1152 19.414 13.341 20.303L14.7204 18.9883L15.6604 21.3724C15.6604 21.3724 15.9124 20.4954 16.7264 20.6197C17.5404 20.744 18.8585 21.1851 19.4222 20.8087C19.5741 20.7211 19.7525 20.6915 19.9246 20.7253Z",
        fill: "#00C650"
      }
    ],
    [
      "path",
      {
        d: "M17.2892 16.1703C17.751 16.1703 18.1254 15.796 18.1254 15.3342C18.1254 14.8724 17.751 14.498 17.2892 14.498C16.8274 14.498 16.4531 14.8724 16.4531 15.3342C16.4531 15.796 16.8274 16.1703 17.2892 16.1703Z",
        fill: "#00C650"
      }
    ]
  ],

  fileSpreadsheet: [
    [
      "path",
      {
        opacity: "0.3",
        d: "M23.7852 8.38705C22.8542 8.38615 21.9615 8.01588 21.3032 7.35754C20.6448 6.69921 20.2746 5.80657 20.2737 4.87554V0H4.58268C3.36728 0 2.20165 0.482827 1.34224 1.34224C0.482827 2.20165 0 3.36724 0 4.58263V32.208C0 33.4233 0.482827 34.589 1.34224 35.4484C2.20165 36.3078 3.36728 36.7906 4.58268 36.7906H23.4173C24.6327 36.7906 25.7983 36.3078 26.6578 35.4484C27.5172 34.589 28 33.4233 28 32.208V8.38705H23.7852Z",
        fill: "#00C650"
      }
    ],
    [
      "path",
      {
        d: "M27.9999 8.38705H23.7851C22.8541 8.38615 21.9615 8.01588 21.3031 7.35754C20.6448 6.69921 20.2745 5.80657 20.2736 4.87554V0L27.9999 8.38705Z",
        fill: "#00C650"
      }
    ],
    [
      "path",
      {
        d: "M20.2473 25.6868H7.76124C6.67987 25.6868 5.79944 24.6105 5.79944 23.2856V14.2276C5.79944 12.9044 6.67987 11.8281 7.76124 11.8281H20.2524C21.3321 11.8281 22.2125 12.9044 22.2125 14.2276V23.2856C22.2074 24.6105 21.327 25.6868 20.2473 25.6868ZM7.76124 13.0542C7.23163 13.0542 6.8025 13.5805 6.8025 14.2276V23.2856C6.8025 23.9327 7.23163 24.4589 7.76124 24.4589H20.2524C20.7803 24.4589 21.2095 23.9327 21.2095 23.2856V14.2276C21.2095 13.5805 20.7803 13.0542 20.2524 13.0542H7.76124Z",
        fill: "#00C650"
      }
    ],
    ["path", { d: "M21.705 20.2324H6.29492V21.4603H21.705V20.2324Z", fill: "#00C650" }],
    ["path", { d: "M21.705 16.0234H6.29492V17.2513H21.705V16.0234Z", fill: "#00C650" }],
    ["path", { d: "M17.7586 12.4414H16.5308V25.0722H17.7586V12.4414Z", fill: "#00C650" }],
    ["path", { d: "M11.4698 12.4414H10.242V25.0722H11.4698V12.4414Z", fill: "#00C650" }]
  ],

  filePdf: [
    [
      "path",
      {
        opacity: "0.3",
        d: "M23.7837 8.38655C22.8528 8.38565 21.9602 8.0154 21.3019 7.3571C20.6436 6.69881 20.2734 5.80622 20.2725 4.87525V0H4.58237C3.36705 0 2.20151 0.482798 1.34215 1.34216C0.482788 2.20152 0 3.36704 0 4.58236V32.206C0.00180475 33.4202 0.485384 34.584 1.34455 35.4419C2.20372 36.2997 3.36823 36.7816 4.58237 36.7816H23.4176C24.6318 36.7816 25.7963 36.2997 26.6555 35.4419C27.5146 34.584 27.9982 33.4202 28 32.206V8.38655H23.7837Z",
        fill: "#FF3E4C"
      }
    ],
    [
      "path",
      {
        d: "M27.9999 8.38655H23.7837C22.8527 8.38565 21.9601 8.0154 21.3018 7.3571C20.6435 6.69881 20.2733 5.80622 20.2724 4.87525V0L27.9999 8.38655Z",
        fill: "#FF3E4C"
      }
    ],
    [
      "path",
      {
        d: "M22.2388 25.6856H4.65859C4.48923 25.6856 4.3268 25.6183 4.20705 25.4986C4.08729 25.3788 4.02002 25.2164 4.02002 25.047C4.02047 24.878 4.08795 24.716 4.20765 24.5966C4.32736 24.4772 4.48952 24.4102 4.65859 24.4102H22.2388C22.4077 24.4102 22.5697 24.4772 22.6892 24.5967C22.8086 24.7161 22.8757 24.8781 22.8757 25.047C22.8759 25.1308 22.8596 25.2138 22.8277 25.2913C22.7958 25.3687 22.7489 25.4391 22.6898 25.4984C22.6306 25.5577 22.5603 25.6048 22.483 25.6369C22.4056 25.6691 22.3226 25.6856 22.2388 25.6856Z",
        fill: "#FF3E4C"
      }
    ],
    [
      "path",
      {
        d: "M22.2388 18.4922H4.65859C4.48952 18.4922 4.32736 18.4252 4.20765 18.3058C4.08795 18.1864 4.02047 18.0244 4.02002 17.8554C4.02002 17.686 4.08729 17.5235 4.20705 17.4038C4.3268 17.284 4.48923 17.2168 4.65859 17.2168H22.2388C22.3226 17.2168 22.4056 17.2333 22.483 17.2654C22.5603 17.2975 22.6306 17.3446 22.6898 17.4039C22.7489 17.4632 22.7958 17.5337 22.8277 17.6111C22.8596 17.6886 22.8759 17.7716 22.8757 17.8554C22.8757 18.0243 22.8086 18.1863 22.6892 18.3057C22.5697 18.4251 22.4077 18.4922 22.2388 18.4922Z",
        fill: "#FF3E4C"
      }
    ],
    [
      "path",
      {
        d: "M22.2388 22.0899H4.65859C4.48923 22.0899 4.3268 22.0226 4.20705 21.9028C4.08729 21.7831 4.02002 21.6207 4.02002 21.4513C4.02047 21.2823 4.08795 21.1203 4.20765 21.0009C4.32736 20.8815 4.48952 20.8145 4.65859 20.8145H22.2388C22.4077 20.8145 22.5697 20.8816 22.6892 21.001C22.8086 21.1204 22.8757 21.2824 22.8757 21.4513C22.8759 21.5351 22.8596 21.6181 22.8277 21.6956C22.7958 21.773 22.7489 21.8434 22.6898 21.9028C22.6306 21.9621 22.5603 22.0091 22.483 22.0412C22.4056 22.0734 22.3226 22.0899 22.2388 22.0899Z",
        fill: "#FF3E4C"
      }
    ],
    [
      "path",
      {
        d: "M15.3048 14.8965H4.65859C4.48952 14.8965 4.32736 14.8295 4.20765 14.7101C4.08795 14.5907 4.02047 14.4287 4.02002 14.2597C4.02002 14.0903 4.08729 13.9279 4.20705 13.8081C4.3268 13.6884 4.48923 13.6211 4.65859 13.6211H15.3048C15.4739 13.6215 15.6359 13.689 15.7553 13.8087C15.8747 13.9284 15.9417 14.0906 15.9417 14.2597C15.9412 14.4284 15.874 14.5902 15.7547 14.7095C15.6353 14.8288 15.4736 14.8961 15.3048 14.8965Z",
        fill: "#FF3E4C"
      }
    ],
    [
      "path",
      {
        d: "M15.3048 11.3008H4.65859C4.48952 11.3008 4.32736 11.2338 4.20765 11.1144C4.08795 10.995 4.02047 10.833 4.02002 10.664C4.02002 10.4946 4.08729 10.3321 4.20705 10.2124C4.3268 10.0926 4.48923 10.0254 4.65859 10.0254H15.3048C15.4739 10.0258 15.6359 10.0933 15.7553 10.213C15.8747 10.3327 15.9417 10.4949 15.9417 10.664C15.9412 10.8327 15.874 10.9944 15.7547 11.1138C15.6353 11.2331 15.4736 11.3004 15.3048 11.3008Z",
        fill: "#FF3E4C"
      }
    ],
    [
      "path",
      {
        d: "M21.9267 10.0254H18.9161C18.3913 10.0254 17.9659 10.4508 17.9659 10.9756V13.9862C17.9659 14.511 18.3913 14.9364 18.9161 14.9364H21.9267C22.4515 14.9364 22.8769 14.511 22.8769 13.9862V10.9756C22.8769 10.4508 22.4515 10.0254 21.9267 10.0254Z",
        fill: "#FF3E4C"
      }
    ]
  ],

  fileDoc: [
    [
      "path",
      {
        opacity: "0.3",
        d: "M23.7837 8.38654C22.8528 8.38564 21.9602 8.0154 21.3019 7.3571C20.6436 6.6988 20.2734 5.80622 20.2725 4.87524V3.16481e-07H4.58408C3.98217 -0.000223358 3.38611 0.118118 2.82995 0.348303C2.2738 0.578489 1.76846 0.916001 1.34276 1.34154C0.917069 1.76707 0.579381 2.2723 0.348989 2.82837C0.118597 3.38444 -4.15598e-08 3.98045 0 4.58236V32.206C-4.15598e-08 32.8079 0.118597 33.404 0.348989 33.96C0.579381 34.5161 0.917069 35.0213 1.34276 35.4469C1.76846 35.8724 2.2738 36.2099 2.82995 36.4401C3.38611 36.6703 3.98217 36.7886 4.58408 36.7884H23.4176C24.0194 36.7884 24.6153 36.6699 25.1712 36.4396C25.7272 36.2093 26.2323 35.8718 26.6579 35.4463C27.0834 35.0207 27.4209 34.5156 27.6512 33.9596C27.8815 33.4037 28 32.8078 28 32.206V8.38654H23.7837Z",
        fill: "#0072FF"
      }
    ],
    [
      "path",
      {
        d: "M27.9993 8.38655H23.783C22.8521 8.38564 21.9595 8.0154 21.3012 7.3571C20.6429 6.6988 20.2727 5.80622 20.2718 4.87524V0L27.9993 8.38655Z",
        fill: "#0072FF"
      }
    ],
    [
      "path",
      {
        d: "M22.2415 14.2579H4.66122C4.49231 14.2579 4.33033 14.1908 4.2109 14.0713C4.09146 13.9519 4.02436 13.7899 4.02436 13.621C4.02413 13.5372 4.04045 13.4542 4.07235 13.3767C4.10426 13.2993 4.15113 13.2289 4.21029 13.1695C4.26945 13.1102 4.33974 13.0632 4.41712 13.0311C4.4945 12.999 4.57744 12.9824 4.66122 12.9824H22.2415C22.4108 12.9824 22.5733 13.0497 22.693 13.1695C22.8128 13.2892 22.8801 13.4516 22.8801 13.621C22.8796 13.7901 22.8121 13.9521 22.6924 14.0714C22.5727 14.1908 22.4105 14.2579 22.2415 14.2579Z",
        fill: "#0072FF"
      }
    ],
    [
      "path",
      {
        d: "M22.2415 18.0664H4.66122C4.49231 18.0664 4.33033 17.9993 4.2109 17.8799C4.09146 17.7605 4.02436 17.5985 4.02436 17.4296C4.02413 17.3458 4.04045 17.2628 4.07235 17.1853C4.10426 17.1079 4.15113 17.0375 4.21029 16.9781C4.26945 16.9188 4.33974 16.8718 4.41712 16.8397C4.4945 16.8075 4.57744 16.791 4.66122 16.791H22.2415C22.4108 16.791 22.5733 16.8583 22.693 16.978C22.8128 17.0978 22.8801 17.2602 22.8801 17.4296C22.8796 17.5986 22.8121 17.7606 22.6924 17.88C22.5727 17.9994 22.4105 18.0665 22.2415 18.0664Z",
        fill: "#0072FF"
      }
    ],
    [
      "path",
      {
        d: "M22.2415 21.877H4.66122C4.57744 21.877 4.4945 21.8605 4.41712 21.8284C4.33974 21.7962 4.26945 21.7492 4.21029 21.6899C4.15113 21.6306 4.10426 21.5601 4.07235 21.4827C4.04045 21.4052 4.02413 21.3222 4.02436 21.2384C4.02436 21.0695 4.09146 20.9075 4.2109 20.7881C4.33033 20.6687 4.49231 20.6016 4.66122 20.6016H22.2415C22.4105 20.6016 22.5727 20.6686 22.6924 20.788C22.8121 20.9074 22.8796 21.0694 22.8801 21.2384C22.8801 21.4078 22.8128 21.5702 22.693 21.69C22.5733 21.8097 22.4108 21.877 22.2415 21.877Z",
        fill: "#0072FF"
      }
    ],
    [
      "path",
      {
        d: "M15.3075 25.6856H4.66122C4.57744 25.6856 4.4945 25.6691 4.41712 25.6369C4.33974 25.6048 4.26945 25.5577 4.21029 25.4984C4.15113 25.4391 4.10426 25.3687 4.07235 25.2913C4.04045 25.2138 4.02413 25.1308 4.02436 25.047C4.02436 24.8781 4.09146 24.7161 4.2109 24.5967C4.33033 24.4772 4.49231 24.4102 4.66122 24.4102H15.3075C15.4764 24.4102 15.6384 24.4772 15.7578 24.5967C15.8772 24.7161 15.9443 24.8781 15.9443 25.047C15.9445 25.1308 15.9282 25.2138 15.8963 25.2913C15.8644 25.3687 15.8176 25.4391 15.7584 25.4984C15.6992 25.5577 15.629 25.6048 15.5516 25.6369C15.4742 25.6691 15.3912 25.6856 15.3075 25.6856Z",
        fill: "#0072FF"
      }
    ]
  ],
  userRounded: [
    [
      "circle",
      {
        cx: "9.99984",
        cy: "4.99935",
        r: "3.33333",
        fill: "currentColor",
        stroke: "none"
      }
    ],
    [
      "ellipse",
      {
        cx: "9.99984",
        cy: "14.1673",
        rx: "5.83333",
        ry: "3.33333",
        fill: "currentColor",
        stroke: "none"
      }
    ]
  ],
  usersGroupRounded: [
    [
      "circle",
      {
        cx: "7.50081",
        cy: "4.99935",
        r: "3.33333",
        fill: "currentColor",
        stroke: "none"
      }
    ],
    [
      "ellipse",
      {
        cx: "7.50081",
        cy: "14.1673",
        rx: "5.83333",
        ry: "3.33333",
        fill: "currentColor",
        stroke: "none"
      }
    ],
    [
      "path",
      {
        d: "M17.4996 14.1664C17.4996 15.5471 15.8033 16.6664 13.7322 16.6664C14.3424 15.9995 14.762 15.1623 14.762 14.1676C14.762 13.1717 14.3414 12.3338 13.7301 11.6665C15.8012 11.6665 17.4996 12.7857 17.4996 14.1664Z",
        fill: "currentColor",
        stroke: "none"
      }
    ],
    [
      "path",
      {
        d: "M14.9996 5C14.9996 6.38071 13.8803 7.5 12.4996 7.5C12.1985 7.5 11.9099 7.44678 11.6426 7.34923C12.0368 6.65582 12.262 5.85374 12.262 4.99907C12.262 4.14503 12.0372 3.3435 11.6435 2.65045C11.9105 2.5531 12.1989 2.5 12.4996 2.5C13.8803 2.5 14.9996 3.61929 14.9996 5Z",
        fill: "currentColor",
        stroke: "none"
      }
    ]
  ]
};

// Type-safe icon names
export type CustomIconName = keyof typeof customIcons;
